// GENERATED by `python -m enex_app.core.contracts.ts_types` from the Pydantic contracts.
// Do not edit by hand: change the contract in backend/enex_app/core/contracts and run the generator.

export type Json = unknown;
/** `<prefix>_<ulid>`: 26 lower-case Crockford base32 characters. */
export type Id = string;
/** ISO 8601 in UTC with milliseconds and a Z. */
export type Ts = string;

// Enumerations
export type ElementKind = "item" | "family" | "sub_family" | "library" | "component_kind" | "component" | "capability" | "data_field" | "data_group" | "pick_list" | "document_kind" | "document_link" | "link" | "spec_chapter" | "framework";
export type LineKind = "mapping" | "standards" | "phase_setting" | "at_least_one" | "pick_value" | "symbol" | "line_style";
export type ElementState = "accepted" | "added_by_hand" | "validated" | "sent_back" | "rejected" | "withdrawn" | "removed";
export type LineState = "accepted" | "added_by_hand" | "validated" | "sent_back" | "rejected" | "withdrawn" | "removed";
export type Origin = "work" | "loaded" | "app";
export type Phase = "Conceptual" | "Basic" | "Detail";
export type Requirement = "mandatory" | "optional";
export type SettingSource = "item" | "parent" | "field" | "none";
export type DeliverableKind = "A" | "B" | "C";
export type ValueKind = "text" | "whole_number" | "number" | "choice" | "yes_no" | "date" | "size_designation" | "project_code" | "table";
export type MatchWord = "the_same" | "theirs_is_wider" | "theirs_is_narrower" | "nearly_the_same" | "only_related" | "no_match";
export type Library = "DEXPI" | "CFIHOS" | "ISO15926" | "QUDT" | "UCUM" | "IFC" | "CGMES" | "CAEX";
export type Confidence = "Sure" | "Likely" | "Unsure";
export type CardKind = "element" | "follow_up" | "chapter_section" | "no_home_yet";
export type CardAction = "add" | "change" | "remove";
export type CardStatus = "open" | "waiting_for_lock" | "out_of_date" | "accepted" | "changed_accepted" | "declined" | "closed";
export type CoverageWord = "covered" | "waiting_for_sme" | "proposed" | "missing" | "not_data" | "left_to_other_discipline" | "belongs_to_other_item";
export type SpotKind = "datasheet_line" | "document_line" | "list_column" | "drawing_tag" | "symbol" | "connection" | "requirement" | "title_block_field" | "revision_box_field" | "instruction_like_text" | "picture" | "other";
export type ReadLike = "datasheet" | "pid" | "pfd" | "sld" | "architecture" | "equipment_list" | "specification" | "layout" | "calculation_note";
export type Mode = "guide" | "tutor" | "sme_review" | "explain" | "admin" | "admin_onboarding";
export type Step = "goal_and_item" | "plan" | "read" | "match" | "fill" | "checks" | "hand_over";
export type WorkflowId = "01" | "02" | "03" | "04" | "05" | "06" | "07" | "08" | "09" | "10" | "11" | "12" | "13" | "14" | "15" | "16" | "17" | "18" | "19" | "20" | "21" | "22" | "23";
export type Role = "engineer" | "sme";
export type LinkType = "is_shown_on" | "is_described_by" | "is_specified_by";
export type LockReleaseReason = "saved" | "cancelled" | "session_end" | "idle" | "no_connection" | "account_disabled" | "restore" | "taken_over";
export type Screen = "item_page" | "item_map" | "live_map" | "live_view" | "family_navigator" | "gallery" | "library_browser" | "deliverable_view" | "proposal_tray" | "checks_list" | "files_view" | "sme_inbox" | "restore_control" | "symbol_picker" | "add_by_hand_form" | "admin_accounts" | "admin_model_connection" | "admin_disciplines" | "upload_form" | "open_points" | "chapters" | "project_lists";
export type LogKind = "question_answer" | "reason" | "decision" | "left_out" | "on_request" | "open_point" | "sweep_result" | "instruction_in_deliverable" | "changed_before_accepting" | "declined";
export type TestResultWord = "connected" | "key_refused" | "url_not_reached" | "model_not_found" | "something_else";
export type NoHomeChoice = "add_by_hand" | "kind_of_closest" | "propose_as_data_field" | "belongs_to_other_item" | "not_data" | "left_to_other_discipline" | "later" | "ask_why";
export type LimitOrigin = "our_team" | "dexpi";
export type ItemPart = "own_fields" | "components" | "tie_in_notes" | "component_kinds" | "units" | "data_groups" | "pick_lists" | "capabilities" | "connections" | "links_and_place" | "document_links" | "symbols" | "mapping_lines" | "required_data" | "chapters";
export type MemoryField = "detail_level" | "experience" | "used_in_other_discipline" | "module_status" | "concept_level" | "preference" | "remember" | "reminder_flag" | "working_history" | "discipline_note";
export type RefusalCode = "not_signed_in" | "must_change_password" | "forbidden" | "workspace_closed" | "not_found" | "invalid" | "locked" | "stale" | "blocked" | "code_taken" | "declined_before" | "out_of_scope" | "not_allowed_in_mode" | "limit" | "conflict" | "too_large" | "unreadable_type" | "encrypted" | "needs_confirmation" | "agent_unavailable" | "index_missing" | "unknown_discipline";

// Models
/** Why an element is wanted: the deliverable that needs it (2.4.4). */
export interface NeededBy {
  text: string;
  deliverable_kind?: DeliverableKind | null;
  not_named_yet: boolean;
  deliverable_ids?: Id[];
}

export interface SpaceRef {
  kind: "workspace" | "practice";
  slug: string;
}

export interface Ctx {
  space: SpaceRef;
  workspace_code: string;
  workspace_status: "open" | "closed";
  person_id: Id;
  display_name: string;
  membership_id?: Id | null;
  roles: Role[];
  is_admin: boolean;
  actor_kind: "person" | "agent" | "app";
  turn_id?: Id | null;
  session_id?: Id | null;
  command_id?: string | null;
  mode?: Mode | null;
}

export interface Actor {
  kind: "person" | "agent" | "app";
  person_id?: Id | null;
  membership_id?: Id | null;
  display: string;
  turn_id?: Id | null;
}

export interface Refusal {
  code: RefusalCode;
  message: string;
  details: Json;
}

export interface CommandResult {
  ok: boolean;
  events: number[];
  data: Json;
  refusal?: Refusal | null;
}

/** The body of an error response: `{ok: false, refusal: Refusal}`. */
export interface RefusalBody {
  ok?: false;
  refusal: Refusal;
}

export interface ConnectionEnd {
  range_kind: "item" | "capability" | "connection" | "component_kind";
  range_id: Id;
  run_id?: Id | null;
  max_count?: number | null;
  limit_origin: LimitOrigin;
}

export interface ItemContent {
  main_parent_id?: Id | null;
  abstract: boolean;
  is_connection: boolean;
  subset_ids: Id[];
  capability_ids: Id[];
  shared_field_ids: Id[];
  from_end?: ConnectionEnd | null;
  to_end?: ConnectionEnd | null;
  held_back?: boolean;
  linkml_extra: Json;
}

export interface FamilyContent {
  parent_id: Id;
}

export interface SubFamilyContent {
  parent_id: Id;
}

export interface LibraryContent {
  dexpi_half?: string | null;
}

export interface ComponentKindContent {
  main_parent_id?: Id | null;
  subset_ids: Id[];
  capability_ids: Id[];
  shared_field_ids: Id[];
  tie_in_note?: string | null;
  linkml_extra: Json;
}

export interface ComponentContent {
  item_id: Id;
  component_kind_id: Id;
  max_count?: number | null;
  ordered: boolean;
  limit_origin: LimitOrigin;
  sits_in_component_id?: Id | null;
  linkml_extra: Json;
}

export interface CapabilityContent {
  is_link_end: boolean;
  starter_set: boolean;
  linkml_extra: Json;
}

export interface Unit {
  ucum_code: string;
  symbol: string;
  quantity_kind: string;
  allowed_units: string[];
  quantity_note?: string | null;
}

export interface TableColumn {
  code: string;
  title: string;
  value_kind: ValueKind;
  unit?: Unit | null;
}

export interface DataFieldContent {
  home_kind: "item" | "component_kind" | "capability" | "document_kind" | "shared";
  home_id?: Id | null;
  value_kind: ValueKind;
  unit?: Unit | null;
  pressure_reference?: "gauge" | "absolute" | null;
  pick_list_id?: Id | null;
  size_list_id?: Id | null;
  project_list_kind?: string | null;
  per_operating_case: boolean;
  paired_with_id?: Id | null;
  calculated_from?: string | null;
  written_rule?: string | null;
  table_columns?: TableColumn[] | null;
  data_group_id?: Id | null;
  rank?: number | null;
  required_from_default?: Phase | null;
  required_from_default_per_case?: Record<string, Phase> | null;
  requirement_default?: Requirement | null;
  value_supplied_later: boolean;
  multivalued: boolean;
  framework_field: boolean;
  linkml_extra: Json;
}

export interface DataGroupContent {
  rank?: number | null;
  linkml_extra: Json;
}

export interface ExchangeInfo {
  library: string;
  library_property: string;
  library_pick_list?: string | null;
  built_from_field_ids: Id[];
}

export interface PickListContent {
  list_kind: "pick_list" | "size_designation" | "exchange_table";
  serves_field_ids: Id[];
  exchange?: ExchangeInfo | null;
  linkml_extra: Json;
}

export interface LinkSlot {
  code: string;
  link_type: LinkType;
}

export interface SheetGroup {
  group_code: string;
  fields: string[];
}

export interface DocumentKindContent {
  main_parent_id?: Id | null;
  is_drawing: boolean;
  deliverable_kind?: DeliverableKind | null;
  on_target_list: boolean;
  link_slots: LinkSlot[];
  operating_cases: string[];
  sheet_groups: SheetGroup[];
  printed_labels: Record<string, string>;
  calculated_from: Record<string, string>;
  from_project_record: Record<string, string>;
  linkml_extra: Json;
}

export interface DocumentLinkContent {
  owner_id: Id;
  link_slot_code: string;
  document_kind_id: Id;
  link_type: LinkType;
}

export interface LinkContent {
  owner_id?: Id | null;
  reverse_name: string;
  range_kind: "item" | "capability";
  range_id: Id;
  max_count?: number | null;
  ordered: boolean;
  limit_origin: LimitOrigin;
  shared: boolean;
  linkml_extra: Json;
}

export interface ChapterSectionContent {
  key: string;
  title: string;
  text: string;
}

export interface SpecChapterContent {
  chapter_key: string;
  title: string;
  sections: ChapterSectionContent[];
}

export interface FrameworkContent {
  section: "classes" | "slots" | "enums" | "types" | "subsets";
  file: string;
}

/** Kinds `mapping` and `standards`. */
export interface MappingContent {
  library: Library;
  library_version: string;
  half?: "pid" | "pfd" | null;
  predicate: MatchWord;
  object_id: string;
  object_label?: string | null;
  no_match_reason?: string | null;
  words_searched?: string | null;
  libraries_searched: string[];
  not_searched_by_meaning_yet: boolean;
  library_not_loaded: boolean;
  unchecked: boolean;
  library_classes?: string | null;
  comment?: string | null;
  case_code?: string | null;
  exchange_note?: string | null;
  derived_not_drawn: boolean;
}

/** `element_id` = the field, `context_element_id` = the item. */
export interface PhaseSettingContent {
  field_id: Id;
  item_id: Id;
  component_id?: Id | null;
  phase?: Phase | null;
  per_case?: Record<string, Phase> | null;
  requirement?: Requirement | null;
  discipline?: string | null;
}

/** `element_id` = the component or link. */
export interface AtLeastOneContent {
  target_id: Id;
  phase?: Phase | null;
  line_phase?: Phase | null;
  line_kind_code?: string | null;
  limit_origin: LimitOrigin;
  requirement?: Requirement | null;
  discipline?: string | null;
}

export interface SizeInfo {
  system: string;
  counterpart_code: string;
  source_table: string;
}

export interface PickExchange {
  library_code: string;
  library_text: string;
  combination: Record<string, string>;
  not_carried_by_our_fields?: string | null;
}

export interface PickValueContent {
  code: string;
  title: string;
  description?: string | null;
  value_source?: "sheet" | "library" | "engineer" | null;
  size?: SizeInfo | null;
  exchange?: PickExchange | null;
}

export interface ChosenBy {
  field_id: Id;
  value_code: string;
}

export interface SymbolContent {
  symbol_code: string;
  document_kind_id: Id;
  asset_id?: Id | null;
  chosen_by?: ChosenBy | null;
  shape_version?: number | null;
  points?: Record<string, string> | null;
}

export interface LineStyleDefinition {
  stroke: string;
  width: string;
  dash?: string | null;
  colour?: string | null;
}

export interface LineStyleContent {
  style_code: string;
  document_kind_id: Id;
  asset_id?: Id | null;
  definition?: LineStyleDefinition | null;
  chosen_by?: ChosenBy | null;
  shape_version?: number | null;
}

/** Carried in events. One row of `elements` is ElementData plus the columns of 2.3.2. */
export interface ElementData {
  id: Id;
  code: string;
  kind: ElementKind;
  name: string;
  definition: string;
  discipline?: string | null;
  origin: Origin;
  content: Record<string, Json>;
  homes: Id[];
  raw?: Json | null;
  needed_by?: NeededBy | null;
  source?: string | null;
  proposal_card_id?: string | null;
  replaces_id?: Id | null;
  same_item_as?: string | null;
}

export interface LineData {
  id: Id;
  element_id: Id;
  context_element_id?: Id | null;
  kind: LineKind;
  code?: string | null;
  content: Record<string, Json>;
  origin: Origin;
}

export interface LineChange {
  line_id: Id;
  content: Json;
}

export interface Pending {
  name: string;
  definition: string;
  content: Json;
  lines_added: LineData[];
  lines_changed: LineChange[];
  changes_meaning: boolean;
  reason: string;
  light: boolean;
  status: "waiting" | "sent_back";
  sme_comment?: string | null;
  made_by: Id;
  made_event: number;
  card_id?: string | null;
  code?: string | null;
  discipline?: string | null;
}

/** The same shape as `Pending` for a line, without `lines_added`, `lines_changed` and `code`. */
export interface LinePending {
  name: string;
  definition: string;
  content: Json;
  changes_meaning: boolean;
  reason: string;
  light: boolean;
  status: "waiting" | "sent_back";
  sme_comment?: string | null;
  made_by: Id;
  made_event: number;
  card_id?: string | null;
}

export interface Removal {
  reason: string;
  status: "waiting" | "sent_back";
  sme_comment?: string | null;
  marked_by: Id;
  marked_event: number;
  used_in: number;
}

export interface Note {
  id: Id;
  element_id: Id;
  line_id?: Id | null;
  author_id: Id;
  kind: "sme_note" | "engineer_note" | "card_comment";
  text: string;
  answers_id?: Id | null;
  card_id?: string | null;
  at_event: number;
}

export interface CheckResult {
  code?: string | null;
  severity: "error" | "warning" | "note";
  element_id: Id;
  line_id?: Id | null;
  message: string;
  blocks: boolean;
}

export interface CheckCounts {
  errors: number;
  warnings: number;
  notes: number;
  waiting_for_home: number;
}

export interface CheckReport {
  counts: CheckCounts;
  results: CheckResult[];
}

export interface Blocker {
  code: "MAP-01" | "MAP-02" | "PID-01" | "PFD-01" | "UNIT-01" | "HOME";
  message: string;
  ref?: Id | null;
}

export interface RebuildLine {
  label: string;
  field_ref?: string | null;
  spot_id?: Id | null;
  result: "tick" | "cross" | "template_text_kept" | "not_data" | "needs_project_record";
  tick_state?: "validated" | "loaded" | "waiting" | null;
  gap_workflow?: WorkflowId | null;
}

export interface SpotWord {
  spot_id: Id;
  word: CoverageWord;
}

export interface AcrossItems {
  item: string;
  spots: number;
  covered: number;
  waiting: number;
  parked: number;
}

export interface CoverageReport {
  deliverable_id: Id;
  item_id?: Id | null;
  computed_event: number;
  shares: Record<string, number>;
  covered_validated: number;
  covered_loaded: number;
  spot_words: SpotWord[];
  rebuild: RebuildLine[];
  closing: "goal_met" | "partly_met" | "not_met";
  closing_text: string;
  left: string[];
  phase_filter?: Phase | null;
  across_items?: AcrossItems[] | null;
}

export interface PartStatus {
  part: ItemPart;
  word: "filled" | "waiting_for_sme" | "not_started" | "none_needed";
  reason?: string | null;
  count: number;
}

export interface ItemParts {
  item_id: Id;
  focus: Id[];
  parts: PartStatus[];
}

export interface Aim {
  deliverable_text?: string | null;
  deliverable_kind?: DeliverableKind | null;
  use_text?: string | null;
  not_named_yet: boolean;
}

export interface PlanEstimate {
  count: number;
  unit: string;
  is_estimate: boolean;
}

export interface PlanStep {
  title: string;
  workflow_id: WorkflowId;
  expects: string;
  estimate?: PlanEstimate | null;
}

export interface PlanItem {
  element_id?: Id | null;
  new_item_name?: string | null;
}

export interface Plan {
  goal: string;
  item: PlanItem;
  aim: Aim;
  stopping_rule?: string | null;
  focus_component_ids: Id[];
  element_kinds: ElementKind[];
  deliverable_ids: Id[];
  steps: PlanStep[];
  known_already: string[];
  will_come_out: string;
}

export interface StopPoint {
  step?: Step | null;
  workflow_id?: WorkflowId | null;
  batch_id?: Id | null;
  open_card_ids: string[];
  note?: string | null;
}

export interface HandOverElement {
  element_id: Id;
  line_count: number;
  blocked: boolean;
  blocked_reasons: string[];
  held_back: boolean;
  unsure: boolean;
  tags: ("reworked" | "loaded_changed" | "your_own_work" | "lines_only" | "minimal_item")[];
}

export interface UnsureEntry {
  element_id: Id;
  reason: string;
}

export interface ValueDecision {
  element_ref: string;
  verdict: string;
  reason: string;
  deliverable_named?: string | null;
}

export interface HandOverCoverage {
  covered_validated: number;
  covered_loaded: number;
  waiting: number;
  missing: number;
}

export interface ParkedByItem {
  item_name: string;
  count: number;
}

export interface PressureSetting {
  field_id: Id;
  setting?: string | null;
  question?: string | null;
}

export interface HandOverChecks {
  errors: number;
  warnings: number;
  notes: number;
}

export interface HandOverSummary {
  unsure: UnsureEntry[];
  homes_first_hints: string[];
  value_decisions: ValueDecision[];
  map01_will_block: Id[];
  checks: HandOverChecks;
  coverage?: HandOverCoverage | null;
  open_points: Id[];
  parked_by_item: ParkedByItem[];
  parts_strip?: ItemParts | null;
  open_notes: Id[];
  open_cards: string[];
  connections_open_own_session: Id[];
  pressure_settings: PressureSetting[];
  taker_lines: string[];
  printed_once_in?: string | null;
}

export interface Locator {
  page?: number | null;
  box?: [number, number, number, number] | null;
  sheet?: string | null;
  cell?: string | null;
  range?: string | null;
  xml_id?: string | null;
  xml_path?: string | null;
  heading_path?: string[] | null;
  line_no?: number | null;
  region?: [number, number, number, number] | null;
  tile?: string | null;
}

export interface SpotHome {
  element_id?: Id | null;
  line_id?: Id | null;
}

export interface Spot {
  id: Id;
  deliverable_id: Id;
  block?: string | null;
  kind: SpotKind;
  locator: Locator;
  text_read: string;
  unit_printed?: string | null;
  readable: boolean;
  in_scope: boolean;
  hint?: string | null;
  coverage_word?: CoverageWord | null;
  home?: SpotHome | null;
  how_it_fits?: string | null;
  item_names_seen: string[];
  item_name_norm?: string | null;
  not_data_reason?: string | null;
  parked: boolean;
  stale: boolean;
  unit_ids: string[];
  added_by_hand: boolean;
}

export interface DeliverableData {
  id: Id;
  name: string;
  asset_path: string;
  file_type: string;
  document_kind_id: Id;
  deliverable_kind?: DeliverableKind | null;
  read_like?: ReadLike | null;
  what_i_want: string;
  size_bytes: number;
  pages?: number | null;
  page_range?: string | null;
  sheet_range?: string | null;
  file_hash: string;
  newer_revision_of?: Id | null;
}

export interface MemoryDeliverable {
  name: string;
  kind?: DeliverableKind | null;
}

export interface MemoryLastSession {
  item?: string | null;
  step?: string | null;
  batch?: string | null;
  open_cards: number;
}

export interface WorkingHistory {
  items: string[];
  deliverables: MemoryDeliverable[];
  last_session?: MemoryLastSession | null;
}

export interface ChangedByAgent {
  field: string;
  at: Ts;
}

/** Follows the fixed schema of user-memory.md, section 2. Free text is cut to 200 characters, lists to 50 entries. */
export interface PersonMemory {
  role: "engineer" | "sme" | "engineer_and_sme" | "admin";
  discipline?: string | null;
  experience?: "no" | "a_little" | "yes" | null;
  used_in_other_discipline?: boolean | null;
  detail_level: "short" | "normal" | "full";
  modules: Record<string, "not_started" | "started" | "done" | "skipped" | "known">;
  concepts: Record<string, "not_seen" | "explained" | "practised" | "shown">;
  working_history: WorkingHistory;
  preferences: string[];
  remember: string[];
  reminders: Record<string, boolean>;
  changed_by_agent: ChangedByAgent[];
}

export interface ElementChanges {
  name?: string | null;
  definition?: string | null;
  content?: Json | null;
  needed_by?: NeededBy | null;
  homes?: Id[] | null;
  discipline?: string | null;
}

export interface AssetData {
  id: Id;
  kind: string;
  path: string;
  hash: string;
  mime: string;
  code?: string | null;
  document_kind_id?: Id | null;
  shape?: Json | null;
  keep_versions?: number[] | null;
  withdrawn?: boolean | null;
  replaced_by?: string | null;
  reason?: string | null;
}

export interface OpenPointData {
  id: Id;
  scope: Json;
  kind: string;
  text: string;
  raised_by: string;
}

export interface LogEntryData {
  id: Id;
  session_id?: Id | null;
  kind: LogKind;
  text: string;
  scope: Json;
  verdict?: string | null;
  deliverable_named?: string | null;
  element_ref?: string | null;
  turn_id?: Id | null;
}

export interface HandOverData {
  id: string;
  session_id: Id;
  engineer_id: Id;
  elements: HandOverElement[];
  notes: string[];
  summary: HandOverSummary;
  questions: string[];
  cut_index: number;
  cut_total: number;
}

export interface RestoreConflict {
  element_id: Id;
  reason: string;
}

export interface RestoreColleague {
  membership_id: Id;
  display: string;
  elements: Id[];
}

export interface RestorePreview {
  to_event: number;
  withdrawn: Id[];
  reverted: Id[];
  brought_back: Id[];
  next_versions: Id[];
  kept_validated: Id[];
  kept_change_by_card: Id[];
  listed_for_removal: Id[];
  conflicts: RestoreConflict[];
  colleagues: RestoreColleague[];
}

export interface LibraryTermRef {
  library: Library;
  term_id: string;
}

export interface Source {
  kind: "spot" | "discussion" | "library";
  spot_ids: Id[];
  text: string;
  approximate: boolean;
  discussion_at?: Ts | null;
  library_term?: LibraryTermRef | null;
}

export interface LineDraft {
  client_key: string;
  kind: LineKind;
  content: Json;
  line_id?: Id | null;
  code?: string | null;
}

export interface CardWhat {
  element_kind: ElementKind;
  action?: CardAction | null;
  name: string;
  definition: string;
  content: Json;
  code_hint?: string | null;
  discipline?: string | null;
}

export interface CardWhere {
  discipline: string;
  home_ids: Id[];
  breadcrumb: string[];
}

export interface NearDuplicate {
  element_id: Id;
  code: string;
  name: string;
  difference: string;
}

/** Computed by the server (B08), never by the model. */
export interface Impact {
  used_in: number;
  changes_items?: number | null;
  near_duplicates: NearDuplicate[];
  files_changed: string[];
  checks: CheckResult[];
  warnings: string[];
}

export interface ConfidenceWord {
  word: Confidence;
  reason: string;
  would_be_sure_if?: string | null;
}

export interface ChangesMeaning {
  value: boolean;
  reason: string;
}

export interface ChapterPart {
  chapter_key: string;
  chapter_title: string;
  section_key: string;
  section_title: string;
  text: string;
}

export interface ClosestElement {
  element_id: Id;
  code: string;
  kind: ElementKind;
  difference: string;
}

export interface NoHomeYet {
  seen: string;
  closest: ClosestElement[];
  likely_main_parent?: string | null;
  likely_breadcrumb: string[];
  looks_drawn_on: Id[];
  suggested_tie_in_note?: string | null;
  simplest_option: string;
  needed_by?: NeededBy | null;
}

/** What the agent sends in `propose`. */
export interface CardDraft {
  card_kind: CardKind;
  target_element_id?: Id | null;
  what?: CardWhat | null;
  where?: CardWhere | null;
  needed_by?: NeededBy | null;
  source: Source;
  library_terms: LineDraft[];
  lines: LineDraft[];
  why: string;
  confidence: ConfidenceWord;
  changes_meaning?: ChangesMeaning | null;
  person_asked: boolean;
  chapter?: ChapterPart | null;
  no_home_yet?: NoHomeYet | null;
}

/** CardBody = CardDraft + { impact: Impact } */
export interface CardBody {
  card_kind: CardKind;
  target_element_id?: Id | null;
  what?: CardWhat | null;
  where?: CardWhere | null;
  needed_by?: NeededBy | null;
  source: Source;
  library_terms: LineDraft[];
  lines: LineDraft[];
  why: string;
  confidence: ConfidenceWord;
  changes_meaning?: ChangesMeaning | null;
  person_asked: boolean;
  chapter?: ChapterPart | null;
  no_home_yet?: NoHomeYet | null;
  impact: Impact;
}

export interface CardDecline {
  reason?: string | null;
  spot_settlement?: "left_to_other_discipline" | "not_data" | null;
}

export interface Card {
  id: string;
  session_id: Id;
  batch_id?: Id | null;
  card_kind: CardKind;
  action?: CardAction | null;
  target_element_id?: Id | null;
  element_kind?: ElementKind | null;
  body: CardBody;
  status: CardStatus;
  closing_reason?: string | null;
  decline?: CardDecline | null;
  made_by_turn_id?: Id | null;
  result_element_id?: Id | null;
  settled_by_id?: Id | null;
  created_event: number;
  updated_event: number;
}

export interface SourceRef {
  kind: "decision" | "library_term" | "element" | "spot" | "skill";
  ref: string;
  label?: string | null;
}

export interface Question {
  text: string;
  must_ask: boolean;
  reason: string;
  answer_type: "pick_one" | "yes_no" | "few_words";
  options: string[];
}

export interface AddByHandDraft {
  kind: "item" | "component_kind" | "document_kind";
  library_id?: Id | null;
  family_id?: Id | null;
  sub_family_id?: Id | null;
  main_parent_id?: Id | null;
  name: string;
  definition: string;
  drawn_on: Id[];
  deliverable_kind?: DeliverableKind | null;
  tie_in_note?: string | null;
  is_connection: boolean;
  abstract: boolean;
}

export interface LeftOut {
  element: string;
  reason: string;
}

export interface CoverageHome {
  spot_id: Id;
  home?: SpotHome | null;
  how_it_fits: string;
}

export interface LogScope {
  item_id?: Id | null;
  element_id?: Id | null;
  deliverable_id?: Id | null;
}

/** Every action input may carry `opens_workflow`. */
export interface ActionInput {
  opens_workflow?: WorkflowId | null;
}

export interface ExplainAction {
  opens_workflow?: WorkflowId | null;
  subject: string;
  text: string;
  sources: SourceRef[];
  detail_level?: "short" | "normal" | "full" | null;
  concept?: string | null;
}

export interface AskAction {
  opens_workflow?: WorkflowId | null;
  intro: string;
  questions: Question[];
}

export interface ShowPlanAction {
  opens_workflow?: WorkflowId | null;
  plan: Plan;
}

export interface ReadDeliverableAction {
  opens_workflow?: WorkflowId | null;
  deliverable_id: Id;
  what_i_want: string;
  pages?: string | null;
  second_pass_items: string[];
  read_like?: ReadLike | "general" | null;
}

export interface FindInOntologyAction {
  opens_workflow?: WorkflowId | null;
  meaning: string;
  element_kind?: ElementKind | null;
  limit?: number;
}

export interface FindInLibraryAction {
  opens_workflow?: WorkflowId | null;
  meaning: string;
  library?: Library | "symbols" | "line_styles" | null;
  half?: "pid" | "pfd" | null;
  term_kind?: string | null;
}

export interface ProposeAction {
  opens_workflow?: WorkflowId | null;
  cards: CardDraft[];
  batch_note?: string | null;
  left_out: LeftOut[];
}

export interface PointToAction {
  opens_workflow?: WorkflowId | null;
  screen: Screen;
  element_id?: Id | null;
  spot_id?: Id | null;
  sentence: string;
  form_draft?: AddByHandDraft | null;
}

export interface RunChecksAction {
  opens_workflow?: WorkflowId | null;
  scope: "session" | "item" | "element" | "workspace";
  element_id?: Id | null;
}

export interface RunCoverageAction {
  opens_workflow?: WorkflowId | null;
  deliverable_id: Id;
  item_id?: Id | null;
  homes: CoverageHome[];
  phase?: Phase | null;
}

export interface MakeRestorePointAction {
  opens_workflow?: WorkflowId | null;
  label: string;
}

export interface LogNoteAction {
  opens_workflow?: WorkflowId | null;
  kind: LogKind;
  text: string;
  scope: LogScope;
  verdict?: "keep" | "on_request" | "leave_out" | null;
  deliverable_named?: string | null;
  element_ref?: string | null;
}

export interface RememberAction {
  opens_workflow?: WorkflowId | null;
  scope: "person" | "discipline";
  field: MemoryField;
  key?: string | null;
  value: string;
  reason: string;
}

export interface PrepareHandOverAction {
  opens_workflow?: WorkflowId | null;
  item_ids: Id[];
  notes: string[];
  questions_for_sme: string[];
}

export interface StartPracticeAction {
  opens_workflow?: WorkflowId | null;
  module: "E1" | "E2" | "E3" | "E4" | "E5" | "E6" | "S1" | "S2" | "S3" | "S4" | "S5" | "refresher";
  topic?: string | null;
}

/** A path from LOADING section 6, or `<path>#<section heading>`. */
export interface OpenSkillTopicAction {
  opens_workflow?: WorkflowId | null;
  topic: string;
}

/** What an action returns to the model. `text` is cut to `agent.tool_result_tokens` with "N more". */
export interface ToolResult {
  ok: boolean;
  text: string;
  data?: Json | null;
}

export interface TextBlock {
  type?: "text";
  text: string;
}

export interface PlanBlock {
  type?: "plan";
  plan: Plan;
  session_id: Id;
  status: "shown" | "go" | "changed";
}

export interface QuestionsBlock {
  type?: "questions";
  block_id: string;
  intro: string;
  questions: Question[];
  answers: Record<string, string>;
}

export interface ExplanationBlock {
  type?: "explanation";
  subject: string;
  text: string;
  sources: SourceRef[];
}

export interface CardsBlock {
  type?: "cards";
  batch_id?: Id | null;
  card_ids: string[];
  summary: string;
  left_out: LeftOut[];
}

export interface PointToBlock {
  type?: "point_to";
  screen: Screen;
  element_id?: Id | null;
  spot_id?: Id | null;
  sentence: string;
  form_draft?: AddByHandDraft | null;
}

export interface HandOverBlock {
  type?: "hand_over";
  hand_over_id: string;
}

export interface NoticeBlock {
  type?: "notice";
  text: string;
  tone: "info" | "warning";
}

export interface DemoBannerBlock {
  type?: "demo_banner";
  text: string;
}

/** The agent's offer of a discipline note (CP-11; completion round): Keep, Change the wording, or Not now. */
export interface NoteOfferBlock {
  type?: "note_offer";
  offer_id: Id;
  draft: string;
  scope: Json;
  status: "offered" | "confirmed" | "dropped";
}

export interface TurnTrigger {
  kind: "person_message" | "session_start" | "session_resume" | "plan_go" | "batch_closed" | "hand_over_returned" | "ask_why" | "hand_added_element" | "long_absence" | "first_sign_in" | "hand_over_arrived" | "restore_done" | "intake_done" | "answer_given" | "session_end";
  conversation_key: string;
  session_id?: Id | null;
  element_id?: Id | null;
  card_id?: string | null;
  line_ref?: string | null;
  text?: string | null;
}

/** The rows an event touches. A projector may read and write only these (BR-7). */
export interface Subjects {
  elements?: Id[];
  lines?: Id[];
  cards?: string[];
  other?: Record<string, string[]>;
}

export interface Cause {
  kind: "card" | "hand_over" | "restore" | "batch" | "session" | "job" | "command";
  id: string;
}

export interface EventDraft {
  type: string;
  v?: number;
  actor: Actor;
  session_id?: Id | null;
  subjects: Subjects;
  payload: Record<string, Json>;
  cause?: Cause | null;
}

/** EventDraft + { number, at, command_id?, prev_hash, hash }. */
export interface Event {
  type: string;
  v?: number;
  actor: Actor;
  session_id?: Id | null;
  subjects: Subjects;
  payload: Record<string, Json>;
  cause?: Cause | null;
  number: number;
  at: Ts;
  command_id?: string | null;
  prev_hash: string;
  hash: string;
}

export interface EventNotice {
  number: number;
  type: string;
  at: Ts;
  actor_display: string;
  summary: string;
  element_ids: Id[];
  line_ids: Id[];
  card_ids: string[];
  session_id?: Id | null;
  new_states: Record<string, string>;
  private_to?: Id | null;
}

export interface PackCounts {
  elements: number;
  lines: number;
}

export interface StarterPackLoaded {
  pack_id: string;
  pack_hash: string;
  profile_version: string;
  counts: PackCounts;
  warnings: string[];
}

export interface ElementLoaded {
  element: ElementData;
  code_space: string;
}

export interface LineLoaded {
  line: LineData;
}

export interface SessionStartedInfo {
  id: Id;
  engineer_id: Id;
  item_id?: Id | null;
  new_item_name?: string | null;
  goal: string;
}

export interface SessionStarted {
  session: SessionStartedInfo;
}

export interface ScopeSet {
  item_id?: Id | null;
  new_item_name?: string | null;
  focus_component_ids: Id[];
  element_kinds: ElementKind[];
}

export interface AimSet {
  aim: Aim;
  stopping_rule?: string | null;
}

export interface PlanShown {
  plan: Plan;
  turn_id: Id;
}

export interface PlanGo {
}

export interface PlanChanged {
  plan: Plan;
}

export interface PlanPaused {
  paused_plan: Plan;
  reason: string;
}

export interface StepEntered {
  step: Step;
  workflow_id?: WorkflowId | null;
}

export interface WorkflowOpened {
  workflow_id: WorkflowId;
  reason: "plan" | "person" | "app" | "agent";
  active_workflows: WorkflowId[];
}

export interface WorkflowClosed {
  workflow_id: WorkflowId;
  active_workflows: WorkflowId[];
}

export interface SessionPaused {
  stop_point: StopPoint;
}

export interface SessionResumed {
}

export interface SessionFinished {
  stop_point: StopPoint;
}

export interface SweepDone {
  workflow_id: WorkflowId;
  results: string[];
}

export interface CouldNotRead {
  locator: Locator;
  reason: string;
}

export interface DeliverableUploaded {
  deliverable: DeliverableData;
  asset: AssetData;
}

export interface DeliverableRefused {
  file_name: string;
  reason_code: RefusalCode;
  message: string;
}

export interface DeliverableAttached {
  deliverable_id: Id;
  session_id: Id;
}

export interface SpotsMarkedStale {
  older_deliverable_id: Id;
  newer_deliverable_id: Id;
  spot_ids: Id[];
}

export interface IntakeStarted {
  job_id: Id;
  deliverable_id: Id;
  pages_total: number;
  calls_estimated: number;
  needs_yes: boolean;
  reader_version: string;
  prompt_version: string;
  read_like?: ReadLike | "general" | null;
}

export interface IntakeConfirmed {
  job_id: Id;
}

export interface IntakePageDone {
  job_id: Id;
  page: number;
  pass: string;
  spots: Spot[];
  could_not_read: CouldNotRead[];
  calls_used: number;
}

export interface IntakeCancelled {
  job_id: Id;
}

export interface DeliverableRead {
  deliverable_id: Id;
  job_id: Id;
  status: "read" | "partly_read" | "failed";
  counts_by_kind: Record<string, number>;
  could_not_read: CouldNotRead[];
}

export interface SpotAddedByHand {
  spot: Spot;
}

export interface SpotCorrected {
  spot_id: Id;
  text_read: string;
  unit_printed?: string | null;
}

export interface SpotScopeSet {
  spot_id: Id;
  in_scope: boolean;
}

export interface SpotNotDataSet {
  spot_id: Id;
  reason: string;
}

export interface SpotHomeProposed {
  spot_id: Id;
  home?: SpotHome | null;
  how_it_fits: string;
  by: "agent" | "person";
  confirmed: boolean;
}

export interface SpotCoverageSet {
  spot_id: Id;
  coverage_word: CoverageWord;
  reason?: string | null;
}

export interface SpotParked {
  spot_id: Id;
  item_name_seen: string;
  item_name_norm: string;
}

export interface ParkedSpotTaken {
  spot_id: Id;
  session_id: Id;
}

export interface AgentTurnStarted {
  turn_id: Id;
  conversation_key: string;
  mode: Mode;
  trigger_kind: string;
}

export interface AgentTurnEnded {
  turn_id: Id;
  model?: string | null;
  tokens_in: number;
  tokens_out: number;
  actions_used: Record<string, number>;
  reason: "done" | "limit" | "interrupted" | "cancelled" | "error";
  message?: string | null;
}

export interface SkillTopicOpened {
  turn_id: Id;
  topic: string;
}

export interface QuestionsAsked {
  turn_id: Id;
  block_id: string;
  intro: string;
  questions: Question[];
}

/** The actor is the person. */
export interface AnswerGiven {
  block_id: string;
  question_index: number;
  answer: string;
}

export interface ExplanationGiven {
  turn_id: Id;
  subject: string;
  sources: SourceRef[];
  concept?: string | null;
}

export interface LogNoteWritten {
  entry: LogEntryData;
}

export interface PointToShown {
  turn_id: Id;
  screen: Screen;
  element_id?: Id | null;
  spot_id?: Id | null;
  sentence: string;
  has_form_draft: boolean;
}

export interface SpotWordPair {
  spot_id: Id;
  word: CoverageWord;
}

/** Status `open`, or `waiting_for_lock` when its element is locked. */
export interface CardProposed {
  card: Card;
}

export interface CardProposedAgain {
  card: Card;
  withdrawn_element_id: Id;
}

export interface CardWaitingForLock {
  card_id: string;
  holder_id: Id;
}

export interface CardOutOfDate {
  card_id: string;
  reason: string;
}

export interface CardAccepted {
  card_id: string;
  element_id: Id;
}

export interface CardChangedAndAccepted {
  card_id: string;
  element_id: Id;
  diff: Json;
}

export interface CardDeclined {
  card_id: string;
  reason?: string | null;
  spot_settlement?: "left_to_other_discipline" | "not_data" | null;
  spot_words: SpotWordPair[];
}

export interface CardAskWhy {
  card_id: string;
  line_ref?: string | null;
}

export interface NoHomeYetSettled {
  card_id: string;
  choice: NoHomeChoice;
  detail: Json;
  spot_words: SpotWordPair[];
  parked_spot_ids: Id[];
}

export interface CardClosed {
  card_id: string;
  reason: "element_gone" | "restore" | "done_by_hand" | "source_gone" | "overtaken";
  element_id?: Id | null;
}

export interface BatchOpened {
  batch_id: Id;
  session_id: Id;
  restore_point_event: number;
}

export interface BatchCounts {
  accepted: number;
  changed: number;
  declined: number;
  open: number;
}

export interface BatchClosed {
  batch_id: Id;
  how: "all_settled" | "closed_by_engineer" | "session_paused" | "session_finished";
  counts: BatchCounts;
}

export interface ElementAddedByHand {
  element: ElementData;
  code_space: string;
  lines: LineData[];
  derived_lines: LineData[];
  cards_closed: string[];
}

export interface ElementAccepted {
  card_id: string;
  batch_id?: Id | null;
  element: ElementData;
  code_space: string;
  lines: LineData[];
  derived_lines: LineData[];
  on_behalf_of_disabled?: Id | null;
}

export interface NewContent {
  name: string;
  definition: string;
  content: Json;
  lines_added: LineData[];
  lines_changed: LineChange[];
  discipline?: string | null;
}

export interface ElementValidated {
  element_id: Id;
  version: number;
  from: "waiting" | "next_version";
  line_ids_validated: Id[];
  new_content?: NewContent | null;
}

export interface ElementSentBack {
  element_id: Id;
  version: number;
  comment: string;
  on: "waiting" | "next_version" | "removal";
}

export interface ElementRejected {
  element_id: Id;
  version: number;
  reason: string;
  on: "waiting" | "next_version";
  open_point?: OpenPointData | null;
}

export interface ElementReworked {
  element_id: Id;
  changes: ElementChanges;
  lines_added: LineData[];
  lines_changed: LineChange[];
  lines_removed: Id[];
  back_to: "accepted" | "added_by_hand";
  card_id?: string | null;
}

export interface ElementReproposed {
  element_id: Id;
  card_id?: string | null;
  reasons: string;
}

export interface ElementWithdrawn {
  element_id: Id;
  dependents: Id[];
  line_ids: Id[];
  replaced_by_id?: Id | null;
  reason?: string | null;
  cards_closed: string[];
  derived_lines_removed: Id[];
  on_behalf_of_disabled?: Id | null;
}

export interface NextVersionMade {
  element_id: Id;
  pending: Pending;
}

export interface NextVersionDropped {
  element_id: Id;
}

/** A second engineer chose "add to it" on a colleague's waiting Next version (DEC-1016-96 R2-07). */
export interface NextVersionAddedTo {
  element_id: Id;
  pending: Pending;
  card_id?: string | null;
}

export interface RemovalMarked {
  element_id: Id;
  removal: Removal;
}

export interface RemovalValidated {
  element_id: Id;
  line_ids: Id[];
}

export interface RemovalRefusedOrLifted {
  element_id: Id;
  by: "sme_reject" | "engineer_lift";
  reason?: string | null;
}

/** A withdrawn element brought back in its state at the restore point. */
export interface ElementBroughtBack {
  element: ElementData;
  state: LineState;
  code: string;
  lines: LineData[];
}

export interface CodeCorrected {
  element_id: Id;
  old_code: string;
  new_code: string;
  code_space: string;
}

export interface ElementEdited {
  element_id: Id;
  changes: ElementChanges;
  lines_added: LineData[];
  lines_changed: LineChange[];
  lines_removed: Id[];
  derived_lines_set: LineData[];
  derived_lines_removed: Id[];
}

export interface NotUsedByUsRecorded {
  element_id: Id;
  note: string;
}

export interface SameItemAsSet {
  element_id: Id;
  text: string;
}

/** An engineer folded a duplicate into the element kept (profile 2.29: change `fold`, `merged_from`). */
export interface DuplicateFolded {
  element_id: Id;
  folded_id: Id;
}

export interface AssetUploaded {
  asset: AssetData;
}

export interface LineAdded {
  line: LineData;
  card_id?: string | null;
  state: LineState;
}

export interface LineEdited {
  line_id: Id;
  content: Json;
}

export interface LineValidated {
  line_id: Id;
}

export interface LineSentBack {
  line_id: Id;
  comment: string;
  on: "waiting" | "next_version" | "removal";
}

export interface LineRejected {
  line_id: Id;
  reason: string;
  on: "waiting" | "next_version";
}

export interface LineReworked {
  line_id: Id;
  content: Json;
  back_to: "accepted" | "added_by_hand";
}

export interface LineWithdrawn {
  line_id: Id;
}

export interface LineNextVersionMade {
  line_id: Id;
  pending: LinePending;
}

export interface LineNextVersionDropped {
  line_id: Id;
}

export interface LineRemovalMarked {
  line_id: Id;
  removal: Removal;
}

export interface LineRemovalValidated {
  line_id: Id;
}

export interface LineRemovalRefusedOrLifted {
  line_id: Id;
  by: "sme_reject" | "engineer_lift";
  reason?: string | null;
}

export interface DerivedLineSet {
  line: LineData;
  cause_element_id: Id;
}

export interface DerivedLineRemoved {
  line_id: Id;
  cause_element_id: Id;
}

export interface SmeNoteAdded {
  note: Note;
}

export interface EngineerNoteAdded {
  note: Note;
}

export interface CardCommentAdded {
  note: Note;
}

export interface LockTaken {
  element_id: Id;
  holder_id: Id;
  session_id?: Id | null;
  taken_at: Ts;
  expires_at?: Ts | null;
}

export interface LockReleaseAsked {
  element_id: Id;
  asked_by: Id;
}

export interface LockReleased {
  element_id: Id;
  reason: LockReleaseReason;
  by?: Id | null;
  cards_reopened: string[];
}

export interface RestorePointMade {
  event_number: number;
  label: string;
  reason: string;
  person_id?: Id | null;
  session_id?: Id | null;
}

export interface RestoreStarted {
  to_event: number;
  preview: RestorePreview;
}

export interface RestoreCounts {
  withdrawn: number;
  reverted: number;
  brought_back: number;
  next_versions: number;
  kept_validated: number;
  kept_change_by_card: number;
  listed_for_removal: number;
  conflicts: number;
}

export interface RestoreConflictEntry {
  element_id: Id;
  reason: string;
}

export interface RestoreDone {
  to_event: number;
  counts: RestoreCounts;
  conflicts: RestoreConflictEntry[];
  listed: Id[];
}

export interface HandOverPrepared {
  hand_over: HandOverData;
}

export interface HandOverEdited {
  hand_over_id: string;
  held_back: Id[];
  released: Id[];
  notes_added: string[];
  questions: string[];
}

export interface HandOverSent {
  hand_over_id: string;
  restore_point_event: number;
  element_ids: Id[];
}

export interface CardDisplayed {
  element_id: Id;
  line_id?: Id | null;
  version: number;
  membership_id: Id;
}

export interface ChapterTextEdited {
  chapter_key: string;
  section_key: string;
  title: string;
  text: string;
  element_id?: Id | null;
}

export interface ChapterSectionSettled {
  card_id: string;
  chapter_key: string;
  section_key: string;
  outcome: "accepted" | "changed_accepted" | "declined";
  text: string;
}

/** The chapter element, state accepted. */
export interface ChapterCompleted {
  element: ElementData;
  code_space?: "chapter";
}

export interface OpenPointLogged {
  open_point: OpenPointData;
}

export interface OpenPointClosed {
  open_point_id: Id;
  reason: string;
}

export interface OpenPointReopened {
  open_point_id: Id;
}

export interface PartMarkedNoneNeeded {
  item_id: Id;
  part: ItemPart;
  reason: string;
}

export interface PartMarkCleared {
  item_id: Id;
  part: ItemPart;
}

/** A kind of document is put on the project's target list, or taken off it (rebuild D5, DEC-1103-05). */
export interface TargetListSet {
  document_kind_id: Id;
  on_target_list: boolean;
}

export interface FilesWriteRequested {
  by: string;
}

export interface FileHash {
  path: string;
  hash: string;
}

export interface FilesRebuilt {
  file_write_id: Id;
  event_rendered: number;
  release: number;
  files: FileHash[];
  changed: string[];
  head_number: number;
  head_hash: string;
  writer_version: string;
  pyyaml_version: string;
}

export interface FileCheckMessage {
  tool: string;
  file: string;
  text: string;
}

export interface FilesCheckFailed {
  file_write_id: Id;
  event_rendered: number;
  messages: FileCheckMessage[];
  elements: Id[];
}

export interface ChecksRunCounts {
  errors: number;
  warnings: number;
  notes: number;
  waiting_for_home: number;
}

export interface ChecksRun {
  scope: "session" | "item" | "element" | "workspace";
  element_id?: Id | null;
  counts: ChecksRunCounts;
}

export interface CoverageRun {
  report_id: Id;
  report: CoverageReport;
}

/** Never the text. */
export interface MemoryUpdated {
  membership_id: Id;
  field: string;
  by: "agent" | "person";
}

export interface MemoryCleared {
  membership_id: Id;
}

export interface DisciplineNoteOffer {
  id: Id;
  draft: string;
  scope: Json;
  turn_id: Id;
}

export interface DisciplineNoteOffered {
  offer: DisciplineNoteOffer;
}

export interface DisciplineNoteWrittenNote {
  id: Id;
  text: string;
  scope: Json;
  agreed_by: Id;
  offer_id?: Id | null;
}

export interface DisciplineNoteWritten {
  note: DisciplineNoteWrittenNote;
}

export interface DisciplineNoteChanged {
  note_id: Id;
  text: string;
  changed_by: Id;
}

export interface DisciplineNoteRemoved {
  note_id: Id;
}

/** The engineer dropped the agent's offer of a discipline note (integration; B10 asked): it can no longer be confirmed. */
export interface DisciplineNoteDropped {
  offer_id: Id;
}

export interface OnboardingProgress {
  membership_id: Id;
  module: string;
  status: string;
}

export interface PracticeStarted {
  membership_id: Id;
  module: string;
  topic?: string | null;
}

export interface PracticeWiped {
  membership_id: Id;
}

export interface VisitEnded {
  membership_id: Id;
  last_event: number;
}

export interface CodeEntry {
  code: string;
  description: string;
}

export interface ProjectCodeList {
  id: Id;
  kind: string;
  codes: CodeEntry[];
  asset_path: string;
}

export interface ProjectCodeListLoaded {
  list: ProjectCodeList;
}

export interface ProjectCodeListReplaced {
  list: ProjectCodeList;
}

/** The copy of `password_reset_by_admin` in each of the person's workspace logs. */
export interface PasswordResetNoted {
  person_id: Id;
}

export interface WorkspaceInfo {
  id: Id;
  code: string;
  slug: string;
  display_name: string;
}

export interface WorkspaceProvisioned {
  workspace: WorkspaceInfo;
  starter_pack_id: string;
}

export interface WorkspaceClosed {
  workspace_id: Id;
}

export interface WorkspaceRestored {
  workspace_id: Id;
  from_code: string;
  archive_hash: string;
}

/** A discipline joins the registry of the installation (rebuild stage 2, DEC-1103-10 part A). */
export interface DisciplineAdded {
  code: string;
  name: string;
}

/** A discipline of the registry is closed: it is listed as closed and takes no new settings (the code stays). */
export interface DisciplineClosed {
  code: string;
}

export interface SettingChanged {
  name: string;
  old: Json;
  new: Json;
}

export interface AccountInfo {
  id: Id;
  username: string;
  display_name: string;
  is_admin: boolean;
}

export interface AccountCreated {
  person: AccountInfo;
}

export interface MembershipInfo {
  id: Id;
  person_id: Id;
  workspace_id: Id;
  roles: Role[];
}

export interface MembershipGranted {
  membership: MembershipInfo;
}

export interface RoleChanged {
  membership_id: Id;
  roles: Role[];
  enabled: boolean;
}

export interface AccountDisabled {
  person_id: Id;
}

export interface AccountEnabled {
  person_id: Id;
}

export interface FirstPasswordSet {
  person_id: Id;
  expires_at: Ts;
}

export interface PasswordResetByAdmin {
  person_id: Id;
  expires_at: Ts;
}

export interface PasswordChanged {
  person_id: Id;
}

export interface SignedIn {
  person_id: Id;
}

/** One aggregated count per minute. */
export interface SignInFailed {
  minute: Ts;
  count: number;
}

export interface SignedOut {
  person_id: Id;
}

/** The key is never in an event: only `key_set`. */
export interface ModelConnectionSet {
  kind: string;
  url: string;
  model_name: string;
  context_size: number;
  key_set: boolean;
}

export interface ModelConnectionRemoved {
}

export interface ModelFound {
  tool_calls: boolean;
  streaming: boolean;
  pictures: boolean;
}

export interface ModelConnectionTested {
  result: TestResultWord;
  found: ModelFound;
}

export interface PersonalKeySet {
  person_id: Id;
  kind: string;
  url?: string | null;
  model_name?: string | null;
}

export interface PersonalKeyRemoved {
  person_id: Id;
}

export interface AdminMemoryUpdated {
  person_id: Id;
  field: string;
}

export interface PersonRef {
  membership_id?: Id | null;
  person_id?: Id | null;
  display: string;
}

export interface AgentStatus {
  available: boolean;
  demo: boolean;
  reason?: string | null;
  model_name?: string | null;
  uses_own_key: boolean;
}

export interface MePerson {
  id: Id;
  username: string;
  display_name: string;
}

export interface MeMembership {
  id: Id;
  workspace_code: string;
  workspace_name: string;
  workspace_status: "open" | "closed";
  roles: Role[];
}

export interface MeActive {
  membership_id: Id;
  workspace_code: string;
  workspace_name: string;
  roles: Role[];
  space: "workspace" | "practice";
}

export interface MeView {
  person: MePerson;
  is_admin: boolean;
  must_change_password: boolean;
  memberships: MeMembership[];
  active?: MeActive | null;
  csrf_token: string;
  agent: AgentStatus;
  version: string;
  password_reset_noted_since?: Ts | null;
}

export interface NotUsedByUs {
  note: string;
}

/** ElementData + the state columns of the API view. */
export interface ElementRow {
  id: Id;
  code: string;
  kind: ElementKind;
  name: string;
  definition: string;
  discipline?: string | null;
  origin: Origin;
  content: Record<string, Json>;
  homes: Id[];
  raw?: Json | null;
  needed_by?: NeededBy | null;
  source?: string | null;
  proposal_card_id?: string | null;
  replaces_id?: Id | null;
  same_item_as?: string | null;
  state?: LineState | null;
  code_fixed: boolean;
  sent_back_from?: string | null;
  pending?: Pending | null;
  removal?: Removal | null;
  not_used_by_us?: NotUsedByUs | null;
  version: number;
  originator?: PersonRef | null;
  accepted_by?: PersonRef | null;
  added_by?: PersonRef | null;
  validated_by?: PersonRef | null;
  validated_at?: Ts | null;
  sme_note?: string | null;
  engineer_note?: string | null;
  sme_comment?: string | null;
  sme_reason?: string | null;
  batch_id?: Id | null;
  waits_for_sme: boolean;
  your_own_work: boolean;
  replaced_by_id?: Id | null;
  pending_by?: PersonRef | null;
  pending_added_by?: PersonRef[];
}

/** LineData + the state columns of the API view. */
export interface LineRow {
  id: Id;
  element_id: Id;
  context_element_id?: Id | null;
  kind: LineKind;
  code?: string | null;
  content: Record<string, Json>;
  origin: Origin;
  state?: LineState | null;
  code_fixed: boolean;
  sme_comment?: string | null;
  sme_reason?: string | null;
  sme_note?: string | null;
  engineer_note?: string | null;
  pending?: LinePending | null;
  removal?: Removal | null;
  version: number;
  waits_for_sme: boolean;
  pending_by?: PersonRef | null;
}

export interface ElementSummary {
  id: Id;
  code: string;
  kind: ElementKind;
  name: string;
  state?: LineState | null;
  origin: Origin;
  discipline?: string | null;
  waits_for_sme: boolean;
  version: number;
}

export interface Crumb {
  element_id?: Id | null;
  label: string;
  level: "library" | "family" | "sub_family" | "main_parent" | "item";
}

export interface LockView {
  element_id: Id;
  holder: PersonRef;
  taken_at: Ts;
  expires_at?: Ts | null;
  release_asked_by?: PersonRef | null;
}

export interface HistoryEntry {
  event: number;
  at: Ts;
  actor: string;
  type: string;
  summary: string;
  comment?: string | null;
  changes_meaning?: boolean | null;
  on_behalf_of?: PersonRef | null;
}

export interface NoteWithAuthor {
  id: Id;
  element_id: Id;
  line_id?: Id | null;
  author_id: Id;
  kind: "sme_note" | "engineer_note" | "card_comment";
  text: string;
  answers_id?: Id | null;
  card_id?: string | null;
  at_event: number;
  author: PersonRef;
}

export interface ElementView {
  element: ElementRow;
  lines: LineRow[];
  notes: NoteWithAuthor[];
  lock?: LockView | null;
  checks: CheckResult[];
  history: HistoryEntry[];
  used_in: number;
  breadcrumb: Crumb[];
  files: string[];
}

export interface DrawnMark {
  code: string;
  asset_id?: Id | null;
  state?: LineState | null;
}

export interface Drawn {
  document_kind_id: Id;
  name: string;
  deliverable_kind?: DeliverableKind | null;
  not_drawn: boolean;
  symbol?: DrawnMark | null;
  line_style?: DrawnMark | null;
}

export interface ComponentKindRef {
  id: Id;
  code: string;
  name: string;
  tie_in_note?: string | null;
}

export interface ComponentSymbol {
  document_kind_id: Id;
  code: string;
  asset_id?: Id | null;
}

export interface DocumentKindRef {
  id: Id;
  name: string;
  deliverable_kind?: DeliverableKind | null;
}

export interface DocumentOnItem {
  document_link_id: Id;
  link_type: LinkType;
  document_kind: DocumentKindRef;
  state?: string | null;
}

export interface ComponentOnMap {
  element: ElementRow;
  kind: ComponentKindRef;
  in_focus: boolean;
  symbols: ComponentSymbol[];
  sits_in?: Id | null;
  documents?: DocumentOnItem[];
}

export interface LineMapInline {
  element_id: Id;
  name: string;
  order: number;
  state?: string | null;
}

export interface LineMapSegment {
  component_id: Id;
  name: string;
  order: number;
  inline_items: LineMapInline[];
  branch_of?: Id | null;
  connection_id?: Id | null;
  connection_name?: string | null;
}

export interface LineMapEnd {
  element_id?: Id | null;
  name: string;
  run_id?: Id | null;
  run_name?: string | null;
}

export interface LineMapEnds {
  from?: LineMapEnd | null;
  to?: LineMapEnd | null;
}

export interface LineMap {
  connection_id: Id;
  segments: LineMapSegment[];
  ends: LineMapEnds;
}

export interface TieInMark {
  component_id: Id;
  note: string;
}

export interface SnapshotFarEnd {
  element_id: Id;
  name: string;
}

export interface Stub {
  kind: "connection" | "link";
  element_id?: Id | null;
  card_id?: string | null;
  name: string;
  at_component_id?: Id | null;
  far_end?: SnapshotFarEnd | null;
  open_own_session: boolean;
  state?: string | null;
}

export interface OtherItem {
  element_id: Id;
  name: string;
}

export interface FaintProposal {
  card_id: string;
  element_kind: ElementKind;
  name: string;
  confidence: Confidence;
  target_id?: Id | null;
  by?: PersonRef | null;
  since?: Ts | null;
  session_id?: Id | null;
}

export interface ParkedCount {
  item_name: string;
  count: number;
}

export interface ItemSnapshot {
  item: ElementRow;
  breadcrumb: Crumb[];
  is_connection: boolean;
  drawn: Drawn[];
  components: ComponentOnMap[];
  tie_in_marks: TieInMark[];
  stubs: Stub[];
  other_items: OtherItem[];
  faint_proposals: FaintProposal[];
  documents: DocumentOnItem[];
  parked: ParkedCount[];
  parts: ItemParts;
  line_map?: LineMap | null;
}

export interface FieldOrigin {
  id: Id;
  name: string;
}

export interface PhaseLamps {
  Conceptual: boolean;
  Basic: boolean;
  Detail: boolean;
}

export interface FieldPhase {
  required_from?: Phase | null;
  per_case?: Record<string, Phase> | null;
  state?: string | null;
  lamps: PhaseLamps;
  requirement?: Requirement | null;
  discipline?: string | null;
  source?: SettingSource | null;
}

export interface FieldGroup {
  id: Id;
  name: string;
  rank?: number | null;
}

/** A kind of document that needs a field on an item, as a link (rebuild stage 2, DEC-1103-05). */
export interface NeededByLink {
  document_kind_id: Id;
  name: string;
  letter?: DeliverableKind | null;
}

export interface FieldOnPage {
  field: ElementRow;
  from: "item" | "parent" | "capability" | "component_kind" | "other_discipline";
  from_element: FieldOrigin;
  unit?: Unit | null;
  pressure_reference?: string | null;
  size_counterpart?: string | null;
  project_list_kind?: string | null;
  project_list_loaded: boolean;
  phase: FieldPhase;
  needed_by_deliverables: string[];
  needed_by_links?: NeededByLink[];
  mapping_lines: LineRow[];
  group?: FieldGroup | null;
}

export interface PlaceOnPage {
  link: ElementRow;
  far_end?: SnapshotFarEnd | null;
}

export interface ChapterRef {
  key: string;
  title: string;
  state?: string | null;
}

export interface DeliverableFilter {
  key: string;
  label: string;
  kind?: DeliverableKind | null;
}

export interface ItemPageFilters {
  deliverables: DeliverableFilter[];
  phases: Phase[];
}

export interface ItemPage {
  item: ElementRow;
  breadcrumb: Crumb[];
  drawn: Drawn[];
  fields: FieldOnPage[];
  components: ComponentOnMap[];
  documents: DocumentOnItem[];
  places: PlaceOnPage[];
  mapping_lines: LineRow[];
  parts: ItemParts;
  chapters: ChapterRef[];
  filters: ItemPageFilters;
  faint_proposals?: FaintProposal[];
}

export interface PresenceEntry {
  membership_id: Id;
  display: string;
  screen: string;
  item_id?: Id | null;
  session_id?: Id | null;
  since: Ts;
}

/** A colleague's open card that looks like this one (completion round, UI-11; DEC-1016-96 R2-10). */
export interface ColleagueProposal {
  card_id: string;
  session_id: Id;
  element_kind?: ElementKind | null;
  name: string;
  by: PersonRef;
  since: Ts;
  difference?: string | null;
}

/** Someone else's Next version waits on the card's target (R2-07): "<by> has a pending change here: add to it, or */
export interface PendingHere {
  by: PersonRef;
  since?: Ts | null;
  light: boolean;
}

/** Card + { lock?, waiting_for?, target?, colleague_proposals, pending_here? } */
export interface CardView {
  id: string;
  session_id: Id;
  batch_id?: Id | null;
  card_kind: CardKind;
  action?: CardAction | null;
  target_element_id?: Id | null;
  element_kind?: ElementKind | null;
  body: CardBody;
  status: CardStatus;
  closing_reason?: string | null;
  decline?: CardDecline | null;
  made_by_turn_id?: Id | null;
  result_element_id?: Id | null;
  settled_by_id?: Id | null;
  created_event: number;
  updated_event: number;
  lock?: LockView | null;
  waiting_for?: string | null;
  target?: ElementSummary | null;
  colleague_proposals?: ColleagueProposal[];
  pending_here?: PendingHere | null;
}

export interface RestorePointView {
  event_number: number;
  at: Ts;
  label: string;
  person?: PersonRef | null;
  session_id?: Id | null;
  reason: string;
  own: boolean;
}

export interface DocumentKindSummary {
  id: Id;
  name: string;
}

export interface DeliverableSummary {
  id: Id;
  name: string;
  document_kind: DocumentKindSummary;
  deliverable_kind?: DeliverableKind | null;
  read_like?: ReadLike | "general" | null;
  reader_status: string;
  pages?: number | null;
  spots_count: number;
}

export interface SessionInfo {
  id: Id;
  engineer: PersonRef;
  item?: ElementSummary | null;
  new_item_name?: string | null;
  goal: string;
  aim?: Aim | null;
  focus: Id[];
  element_kinds: ElementKind[];
  plan?: Plan | null;
  plan_status: string;
  active_workflows: WorkflowId[];
  step?: Step | null;
  status: string;
  stop_point?: StopPoint | null;
  engineer_disabled?: boolean;
}

export interface TrailStep {
  step: Step;
  label: string;
  status: "done" | "current" | "next";
}

export interface BatchView {
  id: Id;
  opened_event: number;
  closed_event?: number | null;
  how_closed?: string | null;
  counts: Json;
}

/** The last sweep of the session (completion round, CP-21): the `sweep_done` event and its lines. */
export interface SweepView {
  event: number;
  at: Ts;
  workflow_id: WorkflowId;
  results: string[];
}

export interface SessionView {
  session: SessionInfo;
  trail: TrailStep[];
  batches: BatchView[];
  open_batch_id?: Id | null;
  open_cards: CardView[];
  deliverables: DeliverableSummary[];
  restore_points: RestorePointView[];
  someone_else_here: PresenceEntry[];
  last_sweep?: SweepView | null;
}

export interface JobView {
  id: Id;
  state: string;
  pages_total: number;
  pages_done: number;
  calls_estimated: number;
  calls_used: number;
  needs_yes: boolean;
}

export interface CouldNotReadView {
  locator: Locator;
  reason: string;
}

/** DeliverableSummary + { ... } */
export interface DeliverableView {
  id: Id;
  name: string;
  document_kind: DocumentKindSummary;
  deliverable_kind?: DeliverableKind | null;
  read_like?: ReadLike | "general" | null;
  reader_status: string;
  pages?: number | null;
  spots_count: number;
  what_i_want: string;
  counts_by_kind: Record<string, number>;
  could_not_read: CouldNotReadView[];
  job?: JobView | null;
  page_images: number[];
  newer_revision_of?: Id | null;
  coverage_report_id?: Id | null;
  page_dpi?: number;
}

export interface SpotPage {
  spots: Spot[];
  total: number;
  page: number;
  page_size: number;
}

export interface InboxEntry {
  element: ElementSummary;
  kind_of_wait: "new" | "next_version" | "light_next_version" | "removal" | "reworked" | "follow_up_lines";
  unsure: boolean;
  blocked: boolean;
  blocked_reasons: string[];
  shown_first_because?: string | null;
  waiting_for?: string | null;
  your_own_work: boolean;
  hand_over_id?: string | null;
  notes_waiting: number;
}

export interface InboxItemRef {
  element_id: Id;
  name: string;
}

export interface InboxGroup {
  item?: InboxItemRef | null;
  breadcrumb: Crumb[];
  is_connection: boolean;
  entries: InboxEntry[];
}

export interface InboxCounts {
  waiting: number;
  unsure: number;
  blocked: number;
}

export interface InboxHandOver {
  id: string;
  engineer: PersonRef;
  sent_at: Ts;
  count: number;
  unsure: number;
  age_days: number;
  walk?: Id[];
}

export interface IdName {
  id: Id;
  name: string;
}

export interface InboxFilters {
  kinds: string[];
  engineers: PersonRef[];
  items: IdName[];
  families: IdName[];
}

export interface Inbox {
  groups: InboxGroup[];
  counts: InboxCounts;
  hand_overs: InboxHandOver[];
  filters: InboxFilters;
}

export interface SmeSource {
  spot?: Spot | null;
  deliverable?: DeliverableSummary | null;
  text?: string | null;
}

/** Where a card sits in the walk (completion round, UI-04): "Card `position` of `total`" of the hand-over, or of the */
export interface CardWalk {
  hand_over_id?: string | null;
  position: number;
  total: number;
}

export interface SmeCardView {
  element: ElementRow;
  breadcrumb: Crumb[];
  state_label: string;
  before?: Json | null;
  after?: Json | null;
  source?: SmeSource | null;
  logic?: string | null;
  confidence?: ConfidenceWord | null;
  engineer_note?: string | null;
  library_lines: LineRow[];
  lines: LineRow[];
  needed_by?: NeededBy | null;
  checks: CheckResult[];
  blockers: Blocker[];
  symbols: Drawn[];
  used_in: number;
  history: HistoryEntry[];
  notes: NoteWithAuthor[];
  your_own_work: boolean;
  loaded_note?: string | null;
  displayed: boolean;
  prev_element_id?: Id | null;
  next_element_id?: Id | null;
  walk?: CardWalk | null;
}

export interface SentBackEntry {
  element: ElementSummary;
  line_id?: Id | null;
  comment: string;
  by: PersonRef;
  at: Ts;
}

export interface NoteWaiting {
  note: Note;
  element: ElementSummary;
}

export interface RejectedEntry {
  element: ElementSummary;
  reason: string;
}

export interface ClosedInfo {
  by: string;
  at: Ts;
  reason: string;
}

export interface OpenPointView {
  id: Id;
  scope: Json;
  kind: string;
  text: string;
  raised_by: string;
  at: Ts;
  closed?: ClosedInfo | null;
}

export interface BackLane {
  sent_back: SentBackEntry[];
  notes_waiting: NoteWaiting[];
  rejected: RejectedEntry[];
  loaded_open_points: OpenPointView[];
}

export interface WhatsNewEntry {
  element: ElementSummary;
  change: "added" | "changed" | "removed" | "validated" | "sent_back" | "rejected" | "handed_over";
  by: PersonRef;
  at: Ts;
  your_own_work: boolean;
}

export interface WhatsNewGroup {
  item?: InboxItemRef | null;
  breadcrumb: Crumb[];
  entries: WhatsNewEntry[];
}

export interface WhatsNew {
  since_event: number;
  first_visit: boolean;
  groups: WhatsNewGroup[];
  your_waiting: ElementSummary[];
  more: number;
}

export interface HistoryFrame {
  event: number;
  at: Ts;
  subject_id: Id;
  subject_kind: "element" | "line";
  kind: string;
  name: string;
  state?: string | null;
  parent_id?: Id | null;
  actor: string;
  discipline?: string | null;
}

export interface HistoryMarker {
  event: number;
  at: Ts;
  kind: "hand_over" | "sme_review" | "restore";
  label: string;
}

export interface HistoryFeed {
  from_event: number;
  to_event: number;
  frames: HistoryFrame[];
  markers: HistoryMarker[];
}

export interface Counters {
  validated: number;
  loaded: number;
  waiting: number;
  proposed: number;
  sent_back: number;
  notes_waiting: number;
}

/** The things that are needed, counted by state (DEC-1103-05; "sent back" is the fifth state, rebuild D6). */
export interface ProgressCounts {
  needed: number;
  validated: number;
  with_expert: number;
  proposed: number;
  sent_back: number;
  missing: number;
}

export interface ProgressByDeliverable {
  document_kind_id: Id;
  name: string;
  letter?: DeliverableKind | null;
  counts: ProgressCounts;
}

export interface ProgressByDiscipline {
  discipline?: string | null;
  counts: ProgressCounts;
}

export interface ProgressByLibrary {
  library_id: Id;
  name: string;
  counts: ProgressCounts;
}

/** One group of needs that is counted whole: a need is in exactly one cell, so the totals are the sum of the cells. */
export interface ProgressCell {
  item_id?: Id | null;
  library_id?: Id | null;
  discipline?: string | null;
  document_kind_id?: Id | null;
  counts: ProgressCounts;
}

/** An element kept out of "Send N to the expert", with the reason (DEC-1103-05: before the expert). */
export interface ProgressHeldBack {
  element_id: Id;
  name: string;
  reason: "check_error" | "not_mapped";
  message: string;
}

/** What stands before the expert: no check error, and mapped to a standard or marked "no match". */
export interface ProgressGates {
  check_errors: number;
  not_mapped: number;
  held_back: ProgressHeldBack[];
}

/** Progress at a phase (DEC-1103-05): validated over everything the target deliverables need. */
export interface ProgressView {
  phase: Phase;
  computed_event: number;
  totals: ProgressCounts;
  by_deliverable: ProgressByDeliverable[];
  by_discipline: ProgressByDiscipline[];
  by_library: ProgressByLibrary[];
  cells: ProgressCell[];
  gates: ProgressGates;
  ready_to_send: number;
}

/** Whether a kind of document is on the project's target list (rebuild D5): the record, else the kind's own flag. */
export interface TargetListEntry {
  document_kind_id: Id;
  on_target_list: boolean;
  default_on_target_list: boolean;
}

export interface TreeProgress {
  validated: number;
  waiting: number;
  total: number;
}

export interface TreeNode {
  id: Id;
  label: string;
  level: string;
  kind: ElementKind;
  parent_id?: Id | null;
  state?: string | null;
  origin: Origin;
  abstract: boolean;
  drawn: boolean;
  progress?: TreeProgress | null;
  counts?: ProgressCounts | null;
}

export interface TreeEdge {
  from: Id;
  to: Id;
  kind: "main_parent" | "heading";
}

export interface FamilyTree {
  nodes: TreeNode[];
  edges: TreeEdge[];
}

export interface BacklogEntry {
  item_name: string;
  item_name_norm: string;
  element_id?: Id | null;
  count: number;
  deliverables: string[];
}

export interface ItemBacklog {
  items: BacklogEntry[];
}

export interface FilesStatus {
  status: "up_to_date" | "writing" | "check_failed" | "never_written";
  event_rendered?: number | null;
  release?: number | null;
  message?: string | null;
  elements?: Id[];
  messages?: FileCheckMessage[];
}

export interface LastStop {
  session_id: Id;
  item_name?: string | null;
  stop_point: StopPoint;
}

export interface BackFromSmeCounts {
  sent_back: number;
  notes: number;
  rejected: number;
}

export interface Welcome {
  last_stop?: LastStop | null;
  back_from_sme: BackFromSmeCounts;
  working: PresenceEntry[];
}

export interface DeliverableTile {
  document_kind_id: Id;
  name: string;
  deliverable_kind?: DeliverableKind | null;
  on_target_list: boolean;
  origin: Origin;
}

export interface HomeEngineer {
  welcome: Welcome;
  goal_suggestions: string[];
  tree: FamilyTree;
  whats_new: WhatsNew;
  deliverable_tiles: DeliverableTile[];
  backlog: ItemBacklog;
  live_feed: EventNotice[];
  counters: Counters;
  files: FilesStatus;
}

export interface HomeSme {
  hand_overs: InboxHandOver[];
  files: FilesStatus;
  whats_new: WhatsNew;
  counters: Counters;
  live_feed: EventNotice[];
}

/** Both homes, when the person holds both roles. */
export interface HomeBoth {
  engineer: HomeEngineer;
  sme: HomeSme;
}

export interface FileEntry {
  path: string;
  kind: "item" | "shared" | "mapping" | "revision_record" | "specification" | "symbol";
  hash: string;
  element_count: number;
  states: Record<string, number>;
}

export interface FilesView {
  status: FilesStatus;
  files: FileEntry[];
}

export interface FilePreviewEntry {
  element_id?: Id | null;
  code: string;
  kind: string;
  state?: string | null;
  discipline?: string | null;
  needed_by?: string | null;
}

export interface FilePreview {
  path: string;
  validated_only: boolean;
  entries: FilePreviewEntry[];
  text: string;
  checked?: boolean;
  messages?: FileCheckMessage[];
}

/** ElementSummary + HandOverElement. */
export interface HandOverElementView {
  element_id: Id;
  line_count: number;
  blocked: boolean;
  blocked_reasons: string[];
  held_back: boolean;
  unsure: boolean;
  tags: ("reworked" | "loaded_changed" | "your_own_work" | "lines_only" | "minimal_item")[];
  id: Id;
  code: string;
  kind: ElementKind;
  name: string;
  state?: LineState | null;
  origin: Origin;
  discipline?: string | null;
  waits_for_sme: boolean;
  version: number;
}

/** HandOverData + { status, sent_event?, elements_view } */
export interface HandOverView {
  id: string;
  session_id: Id;
  engineer_id: Id;
  elements: HandOverElement[];
  notes: string[];
  summary: HandOverSummary;
  questions: string[];
  cut_index: number;
  cut_total: number;
  status: string;
  sent_event?: number | null;
  elements_view: HandOverElementView[];
}

export interface ChapterSectionView {
  key: string;
  title: string;
  text: string;
  status: string;
  card_id?: string | null;
}

export interface ChapterView {
  chapter_key: string;
  title: string;
  element?: ElementRow | null;
  sections: ChapterSectionView[];
}

/** One shape of the symbol library or of this workspace (the symbols change of 2026-10-31). */
export interface SymbolSetItem {
  code: string;
  kind: "symbol" | "line_style";
  title: string;
  kind_of_drawing: string;
  document_kind_id?: Id | null;
  category?: string | null;
  discipline?: string | null;
  origin: "loaded" | "app";
  changed?: boolean;
  shape_version?: number;
  point_names?: string[];
  unsure_points?: string[];
  asset_id?: Id | null;
  used_by: Id[];
  shape: Json;
  withdrawn?: boolean;
  replaced_by?: string | null;
}

export interface SymbolSet {
  items: SymbolSetItem[];
  categories?: string[];
  disciplines?: string[];
}

/** The answer of a command that stores a shape: its code, its version now, and what the engineer should know. */
export interface SymbolSaved {
  code: string;
  kind: "symbol" | "line_style";
  shape_version: number;
  origin: "loaded" | "app";
  changed?: boolean;
  warnings?: string[];
  lines_updated?: number;
}

/** One registration the app can offer, and the stored data it comes from (`source`, in plain words). */
export interface RegistrationCandidate {
  shape_name?: string | null;
  registration_number?: string | null;
  standard?: string | null;
  line_registration?: string | null;
  source: string;
}

export interface RegistrationCandidates {
  code: string;
  kind: "symbol" | "line_style";
  candidates?: RegistrationCandidate[];
}

/** An uploaded drawing turned into a shape, before it is stored. `needs_unit` is true when the drawing gives no size: */
export interface SymbolConversion {
  shape: Json;
  warnings: string[];
  needs_unit: boolean;
  unit_mm: number;
  guessed_points: Json;
}

export interface CodeDescription {
  code: string;
  description: string;
}

export interface ProjectListView {
  id: Id;
  kind: string;
  count: number;
  codes: CodeDescription[];
  loaded_by: PersonRef;
  at: Ts;
}

export interface DisciplineNoteView {
  id: Id;
  text: string;
  scope: Json;
  agreed_by: PersonRef;
  at: Ts;
}

export interface DisciplineView {
  code: string;
  name: string;
  status: string;
}

/** A discipline of the registry as the admin sees it (rebuild stage 2). */
export interface DisciplineAdminView {
  code: string;
  name: string;
  status: string;
  created_at: Ts;
  closed_at?: Ts | null;
}

export interface PersonMemoryView {
  memory: PersonMemory;
}

export interface OnboardingModule {
  module: string;
  title: string;
  status: string;
  can_skip_by_showing: boolean;
}

export interface OnboardingPractice {
  exists: boolean;
  module?: string | null;
  topic?: string | null;
  practice_cards?: number;
}

export interface OnboardingView {
  role: string;
  modules: OnboardingModule[];
  practice: OnboardingPractice;
}

export interface OntologyHit {
  element: ElementSummary;
  rank: number;
  difference?: string | null;
  used_in: number;
}

export interface LibraryInfo {
  library: Library;
  version: string;
  licence: string;
  attribution?: string | null;
  source: string;
  retrieved: string;
  shipped: boolean;
  no_derivatives: boolean;
  terms: number;
}

export interface TermHit {
  library: Library;
  version: string;
  term_id: string;
  label: string;
  definition?: string | null;
  definition_in_original: boolean;
  kind: string;
  half?: string | null;
  source_file: string;
  extra: Json;
  suggested_word?: MatchWord | null;
  rank: number;
}

/** TermHit + { parent?, classes } */
export interface TermView {
  library: Library;
  version: string;
  term_id: string;
  label: string;
  definition?: string | null;
  definition_in_original: boolean;
  kind: string;
  half?: string | null;
  source_file: string;
  extra: Json;
  suggested_word?: MatchWord | null;
  rank: number;
  parent?: string | null;
  classes: string[];
}

export interface LibrarySearchResult {
  query: string;
  by_library: Record<string, TermHit[]>;
  searched_by_meaning: boolean;
  symbols: SymbolSetItem[];
}

export interface ConversationMessage {
  seq: number;
  role: string;
  display: AgentBlock[];
  at: Ts;
  turn_id?: Id | null;
}

export interface RunningTurn {
  turn_id: Id;
  text_so_far: string;
  last_seq?: number;
}

export interface ConversationView {
  key: string;
  messages: ConversationMessage[];
  running_turn?: RunningTurn | null;
}

export interface AdminMembership {
  id: Id;
  workspace_code: string;
  roles: Role[];
  enabled: boolean;
}

export interface AdminPersonView {
  id: Id;
  username: string;
  display_name: string;
  enabled: boolean;
  is_admin: boolean;
  must_change_password: boolean;
  last_sign_in_at?: Ts | null;
  active_now: boolean;
  uses_own_key: boolean;
  memberships: AdminMembership[];
}

/** The key is never part of this view: only `key_set`. */
export interface ModelConnectionView {
  kind: string;
  url: string;
  model_name: string;
  key_set: boolean;
  context_size: number;
  found: ModelFound;
  last_test_result?: string | null;
  last_test_at?: Ts | null;
  least_context_per_mode: Record<string, number>;
  warning?: string | null;
}

export interface TestResult {
  result: TestResultWord;
  message: string;
  found: ModelFound;
}

/** What List models found: the names of the models a service offers, to pick from. */
export interface ModelList {
  result: TestResultWord;
  message: string;
  listed: boolean;
  models: string[];
}

export interface WorkspaceAdminView {
  id: Id;
  code: string;
  display_name: string;
  status: string;
  created_at: Ts;
  closed_at?: Ts | null;
  members: number;
  exports: string[];
}

export interface HealthResponse {
  ok: boolean;
  version: string;
  demo_mode: string;
  agent?: AgentStatus | null;
  index_built: boolean;
}

export interface OkResponse {
  ok: boolean;
}

export interface EventsAfter {
  events: EventNotice[];
  head: number;
  resync_required: boolean;
}

/** LogEntryData + { at } */
export interface SessionLogEntry {
  id: Id;
  session_id?: Id | null;
  kind: LogKind;
  text: string;
  scope: Json;
  verdict?: string | null;
  deliverable_named?: string | null;
  element_ref?: string | null;
  turn_id?: Id | null;
  at: Ts;
}

export interface SessionLog {
  entries: SessionLogEntry[];
  events: EventNotice[];
}

/** RestorePreview + { preview_hash, names } */
export interface RestorePreviewView {
  to_event: number;
  withdrawn: Id[];
  reverted: Id[];
  brought_back: Id[];
  next_versions: Id[];
  kept_validated: Id[];
  kept_change_by_card: Id[];
  listed_for_removal: Id[];
  conflicts: RestoreConflict[];
  colleagues: RestoreColleague[];
  preview_hash: string;
  names?: Record<string, string>;
}

export interface AcceptCardResult {
  card: CardView;
  element?: ElementView | null;
}

/** `{card: CardView}`: the response of decline_card and propose_again. */
export interface CardResult {
  card: CardView;
}

export interface AskWhyResult {
  turn_id?: Id | null;
}

export interface NoHomeYetResult {
  card: CardView;
  form_draft?: AddByHandDraft | null;
}

export interface RestoreResult {
  counts: Json;
  conflicts: Json;
}

export interface PostMessageResult {
  turn_id?: Id | null;
  queued: boolean;
}

export interface AnswerResult {
  turn_id?: Id | null;
}

export interface ElementListResult {
  items: ElementSummary[];
  total: number;
}

/** The `add_by_hand` response: an ElementView with `warnings` for near duplicates. */
export interface ElementViewWithWarnings {
  element: ElementRow;
  lines: LineRow[];
  notes: NoteWithAuthor[];
  lock?: LockView | null;
  checks: CheckResult[];
  history: HistoryEntry[];
  used_in: number;
  breadcrumb: Crumb[];
  files: string[];
  warnings?: string[];
}

/** Every changing request carries a `command_id`, a UUID made by the client (2.1.4). */
export interface CommandBase {
  command_id: string;
}

/** Every command that changes an element or a line carries the version the person saw. */
export interface VersionedCommand {
  command_id: string;
  expected_version: number;
}

export interface SignIn {
  name?: "sign_in";
  username: string;
  password: string;
}

export interface SignOut {
  command_id: string;
  name?: "sign_out";
}

export interface ChangePassword {
  command_id: string;
  name?: "change_password";
  old_password?: string | null;
  new_password: string;
}

export interface SetActiveWorkspace {
  command_id: string;
  name?: "set_active_workspace";
  workspace_code: string;
  space?: "workspace" | "practice" | null;
}

/** The key is tested before it is saved and never shown again. */
export interface SetPersonalKey {
  command_id: string;
  name?: "set_personal_key";
  kind: string;
  url?: string | null;
  model_name?: string | null;
  key: string;
}

/** Ask a service which models it offers, with a key typed in the form, before it is saved. Nothing is stored. */
export interface ListMyModels {
  command_id: string;
  name?: "list_my_models";
  kind: string;
  url?: string | null;
  key: string;
}

export interface RemovePersonalKey {
  command_id: string;
  name?: "remove_personal_key";
}

export interface Me {
  name?: "me";
}

export interface Health {
  name?: "health";
}

export interface Home {
  name?: "home";
}

export interface EventsAfterQuery {
  name?: "events_after";
  after: number;
  limit?: number;
}

export interface LiveFeed {
  name?: "live_feed";
  limit?: number;
}

export interface FamilyTreeQuery {
  name?: "family_tree";
  state?: string | null;
  person?: string | null;
  phase?: Phase | null;
}

export interface ItemSnapshotQuery {
  name?: "item_snapshot";
  id: Id;
  session?: Id | null;
}

export interface ItemPageQuery {
  name?: "item_page";
  id: Id;
  deliverable?: string | null;
  phase?: Phase | null;
}

export interface ItemPartsQuery {
  name?: "item_parts";
  id: Id;
  session?: Id | null;
}

export interface ListElements {
  name?: "list_elements";
  kind?: ElementKind | null;
  state?: string | null;
  q?: string | null;
  limit?: number;
  offset?: number;
}

export interface ElementQuery {
  name?: "element";
  id: Id;
}

export interface FindInOntologyQuery {
  name?: "find_in_ontology";
  q: string;
  kind?: ElementKind | null;
  limit?: number;
}

export interface LibraryList {
  name?: "library_list";
}

export interface LibrarySearch {
  name?: "library_search";
  q: string;
  library?: string | null;
  half?: "pid" | "pfd" | null;
  kind?: string | null;
}

export interface LibraryTerm {
  name?: "library_term";
  library: string;
  term_id: string;
}

export interface ListSessions {
  name?: "list_sessions";
  mine?: boolean | null;
  status?: string | null;
}

export interface SessionQuery {
  name?: "session";
  id: Id;
}

export interface SessionCards {
  name?: "session_cards";
  id: Id;
  status?: string | null;
}

export interface SessionLogQuery {
  name?: "session_log";
  id: Id;
}

export interface ConversationQuery {
  name?: "conversation";
  key: string;
  after_seq?: number | null;
}

export interface ListDeliverables {
  name?: "list_deliverables";
  session?: Id | null;
}

export interface DeliverableQuery {
  name?: "deliverable";
  id: Id;
}

export interface SpotsQuery {
  name?: "spots";
  id: Id;
  page?: number;
  page_size?: number;
  kind?: SpotKind | null;
  coverage?: string | null;
  page_no?: number | null;
}

export interface PageImage {
  name?: "page_image";
  id: Id;
  n: number;
}

export interface ItemBacklogQuery {
  name?: "item_backlog";
}

export interface ChecksList {
  name?: "checks_list";
  scope?: "session" | "item" | "element" | "workspace";
  element?: Id | null;
  session?: Id | null;
}

export interface CoverageReportQuery {
  name?: "coverage_report";
  report_id: Id;
}

/** Answers with the report, or 404. */
export interface LatestCoverage {
  name?: "latest_coverage";
  deliverable: Id;
  item?: Id | null;
}

export interface InboxQuery {
  name?: "inbox";
  kind?: string | null;
  engineer?: string | null;
  item?: Id | null;
  family?: Id | null;
}

export interface SmeCardQuery {
  name?: "sme_card";
  element_id: Id;
}

export interface BackLaneQuery {
  name?: "back_lane";
}

export interface WhatsNewQuery {
  name?: "whats_new";
  since?: string | number | null;
  limit?: number | null;
}

export interface HistoryFeedQuery {
  name?: "history_feed";
  state?: string | null;
  person?: string | null;
}

export interface CountersQuery {
  name?: "counters";
}

export interface FilesViewQuery {
  name?: "files_view";
}

export interface FilePreviewQuery {
  name?: "file_preview";
  path: string;
  validated_only?: boolean;
}

/** The person's own points first, then the others, newest first. */
export interface RestorePoints {
  name?: "restore_points";
}

export interface PreviewRestore {
  name?: "preview_restore";
  n: number;
}

export interface ListHandOvers {
  name?: "list_hand_overs";
  session?: Id | null;
  status?: string | null;
}

export interface HandOverQuery {
  name?: "hand_over";
  id: string;
}

export interface ListChapters {
  name?: "list_chapters";
}

export interface ChapterQuery {
  name?: "chapter";
  key: string;
}

/** The symbol library (the loaded shapes and line styles) with this workspace's own laid over (2026-10-31). */
export interface SymbolSetQuery {
  name?: "symbol_set";
  document_kind?: Id | null;
  kind?: "symbol" | "line_style" | null;
  category?: string | null;
  discipline?: string | null;
  kind_of_drawing?: string | null;
  text?: string | null;
}

/** The whole library as one file, `symbols/symbol-library.yaml` (a SymbolLibrary, shapes keyed by code), made for a */
export interface SymbolLibraryQuery {
  name?: "symbol_library";
}

/** The registrations the app can offer for a shape, each with where it comes from: only data already stored in the */
export interface RegistrationCandidatesQuery {
  name?: "registration_candidates";
  code: string;
}

/** An SVG is served with `Content-Security-Policy: default-src 'none'; style-src 'unsafe-inline'; sandbox`. */
export interface AssetQuery {
  name?: "asset";
  id: Id;
}

export interface ProjectLists {
  name?: "project_lists";
}

export interface OpenPointsQuery {
  name?: "open_points";
  open?: boolean | null;
}

export interface DisciplineNotes {
  name?: "discipline_notes";
}

/** The disciplines of the installation (DEC-1103-03), open or closed: any signed-in person may read the list. */
export interface DisciplinesQuery {
  name?: "disciplines";
}

/** What the target deliverables need at a phase, and how much of it is validated (DEC-1103-05). */
export interface ProgressQuery {
  name?: "progress";
  phase?: Phase;
  scope?: "workspace" | "library" | "item";
  id?: Id | null;
}

export interface Presence {
  name?: "presence";
}

export interface MyMemory {
  name?: "my_memory";
}

export interface OnboardingQuery {
  name?: "onboarding";
}

export interface StartSession {
  command_id: string;
  name?: "start_session";
  item_id?: Id | null;
  new_item_name?: string | null;
  goal: string;
}

export interface SetScope {
  command_id: string;
  name?: "set_scope";
  id: Id;
  item_id?: Id | null;
  new_item_name?: string | null;
  focus_component_ids: Id[];
  element_kinds: ElementKind[];
}

export interface SetAim {
  command_id: string;
  name?: "set_aim";
  id: Id;
  aim: Aim;
  stopping_rule?: string | null;
}

export interface PlanGoCommand {
  command_id: string;
  name?: "plan_go";
  id: Id;
}

export interface ChangePlan {
  command_id: string;
  name?: "change_plan";
  id: Id;
  plan: Plan;
}

export interface EnterStep {
  command_id: string;
  name?: "enter_step";
  id: Id;
  step: Step;
  workflow_id?: WorkflowId | null;
}

/** Also by the agent, under the jump rule (2.7.3). */
export interface OpenWorkflow {
  command_id: string;
  name?: "open_workflow";
  id: Id;
  workflow_id: WorkflowId;
}

export interface PauseSession {
  command_id: string;
  name?: "pause_session";
  id: Id;
  release_locks: boolean;
  note?: string | null;
}

export interface ResumeSession {
  command_id: string;
  name?: "resume_session";
  id: Id;
}

export interface FinishSession {
  command_id: string;
  name?: "finish_session";
  id: Id;
  release_locks: boolean;
  note?: string | null;
}

/** Start the session-end agent turn (`TurnTrigger.kind = "session_end"`, workflow 01 "Pause or finish"). */
export interface SweepSession {
  command_id: string;
  name?: "sweep_session";
  id: Id;
  ending: "pause" | "finish";
}

export interface AttachDeliverable {
  command_id: string;
  name?: "attach_deliverable";
  id: Id;
  deliverable_id: Id;
}

export interface AcceptCard {
  command_id: string;
  name?: "accept_card";
  id: string;
  accept_anyway?: boolean | null;
  add_to_pending?: boolean | null;
}

export interface ChangeAcceptCard {
  command_id: string;
  name?: "change_accept_card";
  id: string;
  what?: CardWhat | null;
  library_terms: LineDraft[];
  lines: LineDraft[];
  needed_by?: NeededBy | null;
  discipline?: string | null;
  accept_anyway?: boolean | null;
  add_to_pending?: boolean | null;
}

export interface DeclineCard {
  command_id: string;
  name?: "decline_card";
  id: string;
  reason?: string | null;
  spot_settlement?: "left_to_other_discipline" | "not_data" | null;
}

export interface AskWhy {
  command_id: string;
  name?: "ask_why";
  id: string;
  line_ref?: string | null;
}

export interface SettleNoHomeYet {
  command_id: string;
  name?: "settle_no_home_yet";
  id: string;
  choice: NoHomeChoice;
  detail: Json;
}

/** Put a kind of document on the project's target list, or take it off (rebuild D5, DEC-1103-05). */
export interface SetTargetList {
  command_id: string;
  name?: "set_target_list";
  id: Id;
  on_target_list: boolean;
}

export interface CloseBatch {
  command_id: string;
  name?: "close_batch";
  id: Id;
}

/** The request body field `name` (the element's name) is `element_name` here, because */
export interface AddByHand {
  command_id: string;
  name?: "add_by_hand";
  kind: ElementKind;
  element_name: string;
  definition: string;
  content: Json;
  lines: LineDraft[];
  needed_by?: NeededBy | null;
  drawn_on: Id[];
  code?: string | null;
  session_id?: Id | null;
  discipline?: string | null;
}

export interface EditElement {
  command_id: string;
  expected_version: number;
  name?: "edit_element";
  id: Id;
  changes: ElementChanges;
  lines_add: LineDraft[];
  lines_change: LineChange[];
  lines_remove: Id[];
  changes_meaning?: ChangesMeaning | null;
  light?: boolean | null;
  add_to_pending?: boolean | null;
}

export interface CorrectCode {
  command_id: string;
  expected_version: number;
  name?: "correct_code";
  id: Id;
  new_code: string;
}

export interface WithdrawElement {
  command_id: string;
  expected_version: number;
  name?: "withdraw_element";
  id: Id;
  confirm_dependents: Id[];
  replaced_by_id?: Id | null;
  reason?: string | null;
  fold?: boolean | null;
}

export interface ProposeAgain {
  command_id: string;
  name?: "propose_again";
  id: Id;
  session_id: Id;
}

export interface Repropose {
  command_id: string;
  expected_version: number;
  name?: "repropose";
  id: Id;
  reasons: string;
}

export interface DropNextVersion {
  command_id: string;
  expected_version: number;
  name?: "drop_next_version";
  id: Id;
}

export interface MarkRemoval {
  command_id: string;
  expected_version: number;
  name?: "mark_removal";
  id: Id;
  reason: string;
}

export interface LiftRemoval {
  command_id: string;
  expected_version: number;
  name?: "lift_removal";
  id: Id;
}

export interface RecordNotUsedByUs {
  command_id: string;
  name?: "record_not_used_by_us";
  id: Id;
  note: string;
}

export interface SetSameItemAs {
  command_id: string;
  name?: "set_same_item_as";
  id: Id;
  text: string;
}

export interface AddLine {
  command_id: string;
  name?: "add_line";
  id: Id;
  line: LineDraft;
}

export interface EditLine {
  command_id: string;
  expected_version: number;
  name?: "edit_line";
  id: Id;
  content: Json;
}

export interface WithdrawLine {
  command_id: string;
  expected_version: number;
  name?: "withdraw_line";
  id: Id;
}

export interface DropLineNextVersion {
  command_id: string;
  expected_version: number;
  name?: "drop_line_next_version";
  id: Id;
}

export interface MarkLineRemoval {
  command_id: string;
  expected_version: number;
  name?: "mark_line_removal";
  id: Id;
  reason: string;
}

export interface LiftLineRemoval {
  command_id: string;
  expected_version: number;
  name?: "lift_line_removal";
  id: Id;
}

/** `symbol_code` names a shape of the library or of this workspace (`asset_id` is still read for a workspace one). */
export interface PickSymbol {
  command_id: string;
  name?: "pick_symbol";
  id: Id;
  document_kind_id: Id;
  kind: "symbol" | "line_style";
  asset_id?: Id | null;
  symbol_code?: string | null;
  chosen_by?: ChosenBy | null;
}

/** Multipart: `command_id`, `file` (an SVG drawing), `code`, `document_kind_id`, `kind`, and optional `unit_mm` (the */
export interface UploadSymbol {
  command_id: string;
  name?: "upload_symbol";
  code: string;
  document_kind_id: Id;
  kind: "symbol" | "line_style";
  unit_mm?: number | null;
  title?: string | null;
  description?: string | null;
  category?: string | null;
}

/** Multipart: `command_id`, `file` (an SVG drawing), optional `unit_mm`. Turns the drawing into a shape and shows it, */
export interface ConvertSymbol {
  command_id: string;
  name?: "convert_symbol";
  unit_mm?: number | null;
}

/** One change to a connection point of a symbol: add, move, rename, remove, set its side or exact angle, confirm a */
export interface ChangeConnectionPoint {
  command_id: string;
  name?: "change_connection_point";
  code: string;
  action: "add" | "move" | "rename" | "remove" | "set_side" | "confirm" | "set_details" | "guess_flow_axis";
  point?: string;
  new_name?: string | null;
  x_mm?: number | null;
  y_mm?: number | null;
  direction?: "north" | "east" | "south" | "west" | null;
  angle_deg?: number | null;
  domain?: "process" | "signal" | null;
  flow?: "in" | "out" | "bidirectional" | null;
  role_hint?: string | null;
  expected_shape_version?: number | null;
}

/** The roles of the connection points of an item's (or component kind's) symbol on one kind of drawing: point name */
export interface SetSymbolPoints {
  command_id: string;
  name?: "set_symbol_points";
  id: Id;
  document_kind_id: Id;
  points: Record<string, string>;
}

/** Withdraw a shape (profile 2.21). A shape this discipline made stays in its file until no element shows it any */
export interface WithdrawSymbol {
  command_id: string;
  name?: "withdraw_symbol";
  code: string;
  replaced_by?: string | null;
  reason?: string | null;
  expected_shape_version?: number | null;
}

/** The marks of a shape this discipline made (profile 2.21, section 5): the engineer's note to the SME (empty */
export interface SetShapeMarks {
  command_id: string;
  name?: "set_shape_marks";
  code: string;
  engineer_note?: string | null;
  unsure?: boolean | null;
  example_content?: boolean | null;
  expected_shape_version?: number | null;
}

/** The registration of a shape: for a symbol the DEXPI shape name, the registration number and its standard */
export interface SetShapeRegistration {
  command_id: string;
  name?: "set_shape_registration";
  code: string;
  shape_name?: string | null;
  registration_number?: string | null;
  standard?: string | null;
  line_registration?: string | null;
  expected_shape_version?: number | null;
}

export interface TakeLock {
  command_id: string;
  name?: "take_lock";
  id: Id;
  session_id?: Id | null;
}

export interface HeartbeatLock {
  command_id: string;
  name?: "heartbeat_lock";
  id: Id;
}

export interface ReleaseLock {
  command_id: string;
  name?: "release_lock";
  id: Id;
  reason: "saved" | "cancelled";
}

export interface AskLock {
  command_id: string;
  name?: "ask_lock";
  id: Id;
}

export interface TakeOverLock {
  command_id: string;
  name?: "take_over_lock";
  id: Id;
}

/** `sme_note` by an SME, `engineer_note` by an engineer, `card_comment` by either. */
export interface AddNote {
  command_id: string;
  name?: "add_note";
  element_id: Id;
  line_id?: Id | null;
  kind: "sme_note" | "engineer_note" | "card_comment";
  text: string;
  answers_id?: Id | null;
  card_id?: string | null;
}

export interface PrepareHandOver {
  command_id: string;
  name?: "prepare_hand_over";
  id: Id;
  item_ids: Id[];
  notes: string[];
  questions_for_sme: string[];
}

export interface EditHandOver {
  command_id: string;
  name?: "edit_hand_over";
  id: string;
  hold_back: Id[];
  release: Id[];
  notes_add: string[];
  questions?: string[] | null;
}

export interface SendHandOver {
  command_id: string;
  name?: "send_hand_over";
  id: string;
}

export interface MakeRestorePoint {
  command_id: string;
  name?: "make_restore_point";
  label: string;
  session_id?: Id | null;
}

export interface Restore {
  command_id: string;
  name?: "restore";
  to_event: number;
  preview_hash: string;
  confirm: true;
}

export interface EditChapterSection {
  command_id: string;
  name?: "edit_chapter_section";
  key: string;
  section: string;
  title: string;
  text: string;
}

/** Make the chapter element (state Added by hand) from the chapter's section drafts, as `add_by_hand` with the kind */
export interface SendChapter {
  command_id: string;
  name?: "send_chapter";
  key: string;
  title: string;
}

export interface SetPartMark {
  command_id: string;
  name?: "set_part_mark";
  id: Id;
  part: ItemPart;
  reason: string;
}

export interface ClearPartMark {
  command_id: string;
  name?: "clear_part_mark";
  id: Id;
  part: ItemPart;
}

/** Multipart: `command_id`, `kind`, `file` (CSV or XLSX of codes and descriptions). */
export interface LoadProjectList {
  command_id: string;
  name?: "load_project_list";
  kind: string;
}

export interface LogOpenPoint {
  command_id: string;
  name?: "log_open_point";
  text: string;
  kind: string;
  scope: Json;
}

export interface CloseOpenPoint {
  command_id: string;
  name?: "close_open_point";
  id: Id;
  reason: string;
}

export interface ReopenOpenPoint {
  command_id: string;
  name?: "reopen_open_point";
  id: Id;
}

export interface RequestFilesWrite {
  command_id: string;
  name?: "request_files_write";
}

export interface RunChecks {
  command_id: string;
  name?: "run_checks";
  scope: "session" | "item" | "element" | "workspace";
  element_id?: Id | null;
}

export interface DisplayCard {
  command_id: string;
  name?: "display_card";
  element_id: Id;
  line_id?: Id | null;
  version: number;
}

export interface Validate {
  command_id: string;
  expected_version: number;
  name?: "validate";
  id: Id;
}

/** A line is sent back through `line_id`. */
export interface SendBack {
  command_id: string;
  expected_version: number;
  name?: "send_back";
  id: Id;
  comment: string;
  line_id?: Id | null;
  value_code?: string | null;
}

export interface Reject {
  command_id: string;
  expected_version: number;
  name?: "reject";
  id: Id;
  reason: string;
}

export interface ValidateLine {
  command_id: string;
  expected_version: number;
  name?: "validate_line";
  id: Id;
}

export interface RejectLine {
  command_id: string;
  expected_version: number;
  name?: "reject_line";
  id: Id;
  reason: string;
}

/** One kind of document inside one file (a file that holds two kinds). */
export interface UploadPart {
  document_kind_id: Id;
  page_range?: string | null;
  sheet_range?: string | null;
}

/** Multipart: the fields below as form fields (`parts` as JSON text), and `file`. */
export interface UploadDeliverable {
  command_id: string;
  name?: "upload_deliverable";
  document_kind_id: Id;
  what_i_want: string;
  read_like?: ReadLike | null;
  newer_revision_of?: Id | null;
  session_id?: Id | null;
  parts?: UploadPart[] | null;
}

/** Also the agent's `read_deliverable`. `read_like`: the engineer's answer to how to read it (DEC-1103-15). */
export interface StartIntake {
  command_id: string;
  name?: "start_intake";
  id: Id;
  what_i_want?: string | null;
  pages?: string | null;
  second_pass_items: string[];
  session_id?: Id | null;
  read_like?: ReadLike | "general" | null;
}

export interface ConfirmIntake {
  command_id: string;
  name?: "confirm_intake";
  id: Id;
}

export interface CancelIntake {
  command_id: string;
  name?: "cancel_intake";
  id: Id;
}

export interface AddSpotByHand {
  command_id: string;
  name?: "add_spot_by_hand";
  deliverable_id: Id;
  kind: SpotKind;
  locator: Locator;
  text_read: string;
  unit_printed?: string | null;
}

export interface CorrectSpot {
  command_id: string;
  name?: "correct_spot";
  id: Id;
  text_read: string;
  unit_printed?: string | null;
}

export interface SetSpotScope {
  command_id: string;
  name?: "set_spot_scope";
  id: Id;
  in_scope: boolean;
}

export interface SetSpotNotData {
  command_id: string;
  name?: "set_spot_not_data";
  id: Id;
  reason: string;
}

export interface SettleSpotHome {
  command_id: string;
  name?: "settle_spot_home";
  id: Id;
  home?: SpotHome | null;
  word?: "left_to_other_discipline" | null;
  note?: string | null;
}

export interface ParkSpot {
  command_id: string;
  name?: "park_spot";
  id: Id;
  item_name: string;
}

export interface StartSessionFromBacklog {
  command_id: string;
  name?: "start_session_from_backlog";
  item_name_norm: string;
  goal?: string | null;
}

/** Also the agent's `run_coverage`. */
export interface RunCoverage {
  command_id: string;
  name?: "run_coverage";
  deliverable_id: Id;
  item_id?: Id | null;
  homes?: CoverageHome[] | null;
  phase?: Phase | null;
}

export interface MessageContext {
  screen?: Screen | null;
  element_id?: Id | null;
  card_id?: string | null;
}

export interface PostMessage {
  command_id: string;
  name?: "post_message";
  key: string;
  text: string;
  context?: MessageContext | null;
}

export interface CancelTurn {
  command_id: string;
  name?: "cancel_turn";
  key: string;
  turn_id: Id;
}

export interface AnswerQuestion {
  command_id: string;
  name?: "answer_question";
  key: string;
  block_id: string;
  question_index: number;
  answer: string;
}

export interface PostAdminMessage {
  command_id: string;
  name?: "post_admin_message";
  key: string;
  text: string;
  context?: MessageContext | null;
}

export interface AdminCancelTurn {
  command_id: string;
  name?: "admin_cancel_turn";
  key: string;
  turn_id: Id;
}

export interface AdminAnswerQuestion {
  command_id: string;
  name?: "admin_answer_question";
  key: string;
  block_id: string;
  question_index: number;
  answer: string;
}

export interface EditMyMemory {
  command_id: string;
  name?: "edit_my_memory";
  set: Record<string, Json>;
  remove: string[];
}

export interface ClearMyMemory {
  command_id: string;
  name?: "clear_my_memory";
}

export interface ConfirmDisciplineNote {
  command_id: string;
  name?: "confirm_discipline_note";
  id: Id;
  text?: string | null;
}

export interface DropDisciplineNote {
  command_id: string;
  name?: "drop_discipline_note";
  id: Id;
}

export interface ChangeDisciplineNote {
  command_id: string;
  name?: "change_discipline_note";
  id: Id;
  text: string;
}

export interface RemoveDisciplineNote {
  command_id: string;
  name?: "remove_discipline_note";
  id: Id;
}

export interface SetModuleStatus {
  command_id: string;
  name?: "set_module_status";
  module: string;
  status: string;
}

/** Also the agent's `start_practice`. */
export interface StartPractice {
  command_id: string;
  name?: "start_practice";
  module: string;
  topic?: string | null;
}

export interface WipePractice {
  command_id: string;
  name?: "wipe_practice";
}

export interface AdminPeople {
  name?: "admin_people";
}

export interface CreateAccount {
  command_id: string;
  name?: "create_account";
  username: string;
  display_name: string;
  first_password?: string | null;
}

export interface DisableAccount {
  command_id: string;
  name?: "disable_account";
  id: Id;
}

export interface EnableAccount {
  command_id: string;
  name?: "enable_account";
  id: Id;
}

export interface ResetPassword {
  command_id: string;
  name?: "reset_password";
  id: Id;
  first_password: string;
}

export interface GrantMembership {
  command_id: string;
  name?: "grant_membership";
  id: Id;
  workspace_code: string;
  roles: Role[];
}

export interface ChangeRoles {
  command_id: string;
  name?: "change_roles";
  id: Id;
  roles: Role[];
  enabled: boolean;
}

/** The registry of disciplines with its closed ones (rebuild stage 2, DEC-1103-10 part A). */
export interface AdminDisciplines {
  name?: "admin_disciplines";
}

export interface AddDiscipline {
  command_id: string;
  name?: "add_discipline";
  code: string;
  display_name: string;
}

export interface CloseDiscipline {
  command_id: string;
  name?: "close_discipline";
  code: string;
}

export interface ModelConnectionQuery {
  name?: "model_connection";
}

/** The key is write-only: it is sealed on the server and never returned. */
export interface SetModelConnection {
  command_id: string;
  name?: "set_model_connection";
  kind: string;
  url: string;
  model_name: string;
  key?: string | null;
  context_size: number;
}

export interface RemoveModelConnection {
  command_id: string;
  name?: "remove_model_connection";
}

/** Ask a service which models it offers. Nothing is stored and the key never comes back. */
export interface ListModels {
  command_id: string;
  name?: "list_models";
  kind: string;
  url: string;
  key?: string | null;
}

export interface TestModelConnection {
  command_id: string;
  name?: "test_model_connection";
}

export interface AdminWorkspaces {
  name?: "admin_workspaces";
}

export interface AddWorkspace {
  command_id: string;
  name?: "add_workspace";
  code: string;
  display_name: string;
}

export interface CloseWorkspace {
  command_id: string;
  name?: "close_workspace";
  code: string;
}

/** Closed workspaces only. */
export interface ExportWorkspace {
  command_id: string;
  name?: "export_workspace";
  code: string;
}

export interface AdminMemoryQuery {
  name?: "admin_memory";
}

export interface EditAdminMemory {
  command_id: string;
  name?: "edit_admin_memory";
  set: Record<string, Json>;
  remove: string[];
}

export interface AdminConversation {
  name?: "admin_conversation";
  key: string;
}

export interface ProposeCards {
  name?: "propose_cards";
  session_id: Id;
  turn_id: Id;
  cards: CardDraft[];
  batch_note?: string | null;
  left_out: LeftOut[];
}

export interface RecordPlan {
  name?: "record_plan";
  session_id: Id;
  turn_id: Id;
  plan: Plan;
}

/** The end of a sweep (completion round, CP-21; workflow-framework 12.3): writes `sweep_done`. */
export interface RecordSweep {
  name?: "record_sweep";
  session_id: Id;
  turn_id: Id;
  workflow_id: WorkflowId;
  results: string[];
}

export interface WriteLogNote {
  name?: "write_log_note";
  session_id?: Id | null;
  turn_id: Id;
  kind: LogKind;
  text: string;
  scope: Json;
  verdict?: string | null;
  deliverable_named?: string | null;
  element_ref?: string | null;
}

export interface RememberPerson {
  name?: "remember_person";
  membership_id: Id;
  field: MemoryField;
  key?: string | null;
  value: string;
  reason: string;
}

export interface OfferDisciplineNote {
  name?: "offer_discipline_note";
  turn_id: Id;
  draft: string;
  scope: Json;
}

export interface WsHello {
  type?: "hello";
  head: number;
  space: SpaceRef;
  workspace_code: string;
  membership_id: Id;
  heartbeat_s: number;
}

export interface WsEvent {
  type?: "event";
  notice: EventNotice;
}

export interface WsHead {
  type?: "head";
  number: number;
}

export interface WsResync {
  type?: "resync";
  reason: string;
}

export interface WsPresence {
  type?: "presence";
  entries: PresenceEntry[];
}

export interface WsLock {
  type?: "lock";
  element_id: Id;
  holder?: PersonRef | null;
  expires_at?: Ts | null;
  release_asked_by?: PersonRef | null;
}

export interface WsFiles {
  type?: "files";
  status: FilesStatus;
}

export interface WsCounts {
  type?: "counts";
  checks: CheckCounts;
  counters: Counters;
}

export interface WsAgentTurnStarted {
  type?: "agent.turn_started";
  turn_id: Id;
  conversation_key: string;
  mode: Mode;
}

export interface WsAgentDelta {
  type?: "agent.delta";
  turn_id: Id;
  seq: number;
  text: string;
}

export interface WsAgentBlock {
  type?: "agent.block";
  turn_id: Id;
  seq: number;
  block: TextBlock | PlanBlock | QuestionsBlock | ExplanationBlock | CardsBlock | PointToBlock | HandOverBlock | NoticeBlock | DemoBannerBlock | NoteOfferBlock;
}

export interface WsAgentTool {
  type?: "agent.tool";
  turn_id: Id;
  seq: number;
  name: string;
  status: "running" | "done" | "refused";
  summary: string;
}

export interface WsAgentTurnEnded {
  type?: "agent.turn_ended";
  turn_id: Id;
  reason: string;
  message?: string | null;
}

export interface WsNotice {
  type?: "notice";
  kind: "sent_back_to_you" | "note_for_you" | "your_lock_released" | "lock_release_asked" | "restore_done" | "memory_changed" | "hand_over_arrived" | "intake_done";
  text: string;
  element_id?: Id | null;
}

export interface WsPointTo {
  type?: "point_to";
  screen: Screen;
  element_id?: Id | null;
  spot_id?: Id | null;
  sentence: string;
  form_draft?: AddByHandDraft | null;
}

export interface WsError {
  type?: "error";
  code: string;
  message: string;
}

/** Every `live.heartbeat_s`; feeds presence and the "no live connection" lock rule. */
export interface WsHeartbeat {
  type?: "heartbeat";
  screen: string;
  item_id?: Id | null;
  session_id?: Id | null;
}

/** The edit form is in use; moves the lock expiry. */
export interface WsStillEditing {
  type?: "still_editing";
  element_id: Id;
}

// Unions
export type AgentBlock = TextBlock | PlanBlock | QuestionsBlock | ExplanationBlock | CardsBlock | PointToBlock | HandOverBlock | NoticeBlock | DemoBannerBlock | NoteOfferBlock;
export type Command = SignIn | SignOut | ChangePassword | SetActiveWorkspace | SetPersonalKey | ListMyModels | RemovePersonalKey | StartSession | SetScope | SetAim | PlanGoCommand | ChangePlan | EnterStep | OpenWorkflow | PauseSession | ResumeSession | FinishSession | SweepSession | AttachDeliverable | AcceptCard | ChangeAcceptCard | DeclineCard | AskWhy | SettleNoHomeYet | SetTargetList | CloseBatch | AddByHand | EditElement | CorrectCode | WithdrawElement | ProposeAgain | Repropose | DropNextVersion | MarkRemoval | LiftRemoval | RecordNotUsedByUs | SetSameItemAs | AddLine | EditLine | WithdrawLine | DropLineNextVersion | MarkLineRemoval | LiftLineRemoval | PickSymbol | UploadSymbol | ConvertSymbol | ChangeConnectionPoint | SetSymbolPoints | WithdrawSymbol | SetShapeMarks | SetShapeRegistration | TakeLock | HeartbeatLock | ReleaseLock | AskLock | TakeOverLock | AddNote | PrepareHandOver | EditHandOver | SendHandOver | MakeRestorePoint | Restore | EditChapterSection | SendChapter | SetPartMark | ClearPartMark | LoadProjectList | LogOpenPoint | CloseOpenPoint | ReopenOpenPoint | RequestFilesWrite | RunChecks | DisplayCard | Validate | SendBack | Reject | ValidateLine | RejectLine | UploadDeliverable | StartIntake | ConfirmIntake | CancelIntake | AddSpotByHand | CorrectSpot | SetSpotScope | SetSpotNotData | SettleSpotHome | ParkSpot | StartSessionFromBacklog | RunCoverage | PostMessage | CancelTurn | AnswerQuestion | PostAdminMessage | AdminCancelTurn | AdminAnswerQuestion | EditMyMemory | ClearMyMemory | ConfirmDisciplineNote | DropDisciplineNote | ChangeDisciplineNote | RemoveDisciplineNote | SetModuleStatus | StartPractice | WipePractice | CreateAccount | DisableAccount | EnableAccount | ResetPassword | GrantMembership | ChangeRoles | AddDiscipline | CloseDiscipline | SetModelConnection | RemoveModelConnection | ListModels | TestModelConnection | AddWorkspace | CloseWorkspace | ExportWorkspace | EditAdminMemory | ProposeCards | RecordPlan | RecordSweep | WriteLogNote | RememberPerson | OfferDisciplineNote;
export type Query = Me | Health | Home | EventsAfterQuery | LiveFeed | FamilyTreeQuery | ItemSnapshotQuery | ItemPageQuery | ItemPartsQuery | ListElements | ElementQuery | FindInOntologyQuery | LibraryList | LibrarySearch | LibraryTerm | ListSessions | SessionQuery | SessionCards | SessionLogQuery | ConversationQuery | ListDeliverables | DeliverableQuery | SpotsQuery | PageImage | ItemBacklogQuery | ChecksList | CoverageReportQuery | LatestCoverage | InboxQuery | SmeCardQuery | BackLaneQuery | WhatsNewQuery | HistoryFeedQuery | CountersQuery | FilesViewQuery | FilePreviewQuery | RestorePoints | PreviewRestore | ListHandOvers | HandOverQuery | ListChapters | ChapterQuery | SymbolSetQuery | SymbolLibraryQuery | RegistrationCandidatesQuery | AssetQuery | ProjectLists | OpenPointsQuery | DisciplineNotes | DisciplinesQuery | ProgressQuery | Presence | MyMemory | OnboardingQuery | AdminPeople | AdminDisciplines | ModelConnectionQuery | AdminWorkspaces | AdminMemoryQuery | AdminConversation;
export type ServerMessage = WsHello | WsEvent | WsHead | WsResync | WsPresence | WsLock | WsFiles | WsCounts | WsAgentTurnStarted | WsAgentDelta | WsAgentBlock | WsAgentTool | WsAgentTurnEnded | WsNotice | WsPointTo | WsError;
export type ClientMessage = WsHeartbeat | WsStillEditing;

export type WsMessage = ServerMessage;

// Constants shared with the server
export const DEMO_BANNER_TEXT = "Demo mode: the agent's answers are recorded examples, not a live model";
export const WS_PATH = "/ws/live";
export const WS_CLOSE_NOT_SIGNED_IN = 4401;
export const WS_CLOSE_MEMBERSHIP_CHANGED = 4403;
export const WS_CLOSE_RESYNC = 4409;
export const WS_CLOSE_ACCOUNT_DISABLED = 4410;
